<template>
  <div>
    <MenuAllCoins ref="menuAllCoins" :selectedMetrics="selectedMetrics" @period-selected="handleSearch" @refresh-clicked="handleSearch" @handle-fetchCoins="fetchCoins" @inflow-days-changed="handleInflowDaysChanged"
      @metrics-changed="handleMetrics" />
    <template v-if="selectedMetrics.length">
      <!-- Binance Chart Group -->
      <div v-for="index in totalChart" :key="'chart-grid-binance-' + index" class="chart-grid binance-chart-group">
        <div class="chart-header text-center">
          <h3>
            Biểu đồ Binance -
            {{
              typeof arrayCoin[index - 1] === "object"
                ? arrayCoin[index - 1]?.coinName
                : arrayCoin[index - 1]
            }}
            <span class="exchange-badge-inline">BINANCE</span>
          </h3>
          <div class="metrics-info">
            <a v-if="getCoinMetrics(arrayCoin[index - 1]).cmcUrl" :href="getCoinMetrics(arrayCoin[index - 1]).cmcUrl"
              target="_blank" rel="noopener noreferrer" class="metric-item metric-item-link">
              <strong>Market Cap:</strong>
              <span>{{ formatCurrency(getCoinMetrics(arrayCoin[index - 1]).marketcap) }}</span>
            </a>
            <div v-else class="metric-item">
              <strong>Market Cap:</strong>
              <span>{{ formatCurrency(getCoinMetrics(arrayCoin[index - 1]).marketcap) }}</span>
            </div>
            <div class="metric-item">
              <strong>FDV:</strong>
              <span>{{ formatCurrency(getCoinMetrics(arrayCoin[index - 1]).fdv) }}</span>
            </div>
            <div class="metric-item">
              <strong>Vol/MCap:</strong>
              <span class="vol-percent">{{ getCoinMetrics(arrayCoin[index - 1]).volMktCapPercent != null ? getCoinMetrics(arrayCoin[index - 1]).volMktCapPercent.toFixed(2) + '%' : '-' }}</span>
            </div>
            <div class="metric-item">
              <strong>OI/MCap:</strong>
              <span class="vol-percent">{{ getCoinMetrics(arrayCoin[index - 1]).oiMktCapPercent != null ? getCoinMetrics(arrayCoin[index - 1]).oiMktCapPercent.toFixed(2) + '%' : '-' }}</span>
            </div>
            <a :href="getLiquidationHeatmapUrl(arrayCoin[index - 1])" target="_blank" rel="noopener noreferrer"
              class="heatmap-btn">
              Liquidation Heatmap
            </a>
            <router-link :to="{ name: 'Orderbook', params: { symbol: arrayCoin[index - 1] } }"
              class="heatmap-btn" title="View Orderbook">
              <i class="fa-solid fa-book-open"></i> Orderbook
            </router-link>
          </div>
        </div>

        <div class="chart-box">
          <div class="chart-container first-chart" v-if="selectedMetrics.includes('openInterest')">
            <canvas :id="chartIds[index - 1]" :key="chartIds[index - 1]" :ref="'chart' + (index - 1)"></canvas>
          </div>

          <div class="chart-container second-chart" v-if="selectedMetrics.includes('longShort')">
            <canvas :id="secondChartIds[index - 1]" :key="secondChartIds[index - 1]"
              :ref="'second-chart' + (index - 1)"></canvas>
          </div>

          <div class="chart-container third-chart" v-if="selectedMetrics.includes('longShort')">
            <canvas :id="thirdChartIds[index - 1]" :key="thirdChartIds[index - 1]"
              :ref="'third-chart' + (index - 1)"></canvas>
          </div>

          <div class="chart-container four-chart" v-if="selectedMetrics.includes('longShort')">
            <canvas :id="fourChartIds[index - 1]" :key="fourChartIds[index - 1]"
              :ref="'four-chart' + (index - 1)"></canvas>
          </div>

          <div class="chart-container five-chart" v-if="selectedMetrics.includes('inflow30d')">
            <canvas :id="fiveChartIds[index - 1]" :key="fiveChartIds[index - 1]"
              :ref="'five-chart' + (index - 1)"></canvas>
          </div>

          <div class="chart-container six-chart" v-if="selectedMetrics.includes('inflow24h')">
            <canvas :id="sixChartIds[index - 1]" :key="sixChartIds[index - 1]"
              :ref="'six-chart' + (index - 1)"></canvas>
          </div>

          <div class="chart-container seven-chart" v-if="selectedMetrics.includes('fundingRate')">
            <canvas :id="sevenChartIds[index - 1]" :key="sevenChartIds[index - 1]"
              :ref="'seven-chart' + (index - 1)"></canvas>
          </div>
        </div>
      </div>

      <!-- MEXC Chart Group -->
      <div v-for="index in totalChart" :key="'chart-grid-mexc-' + index" class="chart-grid mexc-chart-group">
        <div class="chart-header text-center">
          <h3>
            Biểu đồ MEXC -
            {{
              typeof arrayCoin[index - 1] === "object"
                ? arrayCoin[index - 1]?.coinName
                : arrayCoin[index - 1]
            }}
            <span class="exchange-badge-inline">MEXC</span>
          </h3>
        </div>

        <div class="chart-box">
          <div class="chart-container first-chart" v-if="selectedMetrics.includes('openInterest')">
            <canvas :id="mexcChartIds[index - 1]" :key="mexcChartIds[index - 1]"
              :ref="'mexc-chart' + (index - 1)"></canvas>
          </div>

          <div class="chart-container second-chart" v-if="selectedMetrics.includes('longShort')">
            <canvas :id="mexcSecondChartIds[index - 1]" :key="mexcSecondChartIds[index - 1]"
              :ref="'mexc-second-chart' + (index - 1)"></canvas>
          </div>

          <div class="chart-container third-chart" v-if="selectedMetrics.includes('longShort')">
            <canvas :id="mexcThirdChartIds[index - 1]" :key="mexcThirdChartIds[index - 1]"
              :ref="'mexc-third-chart' + (index - 1)"></canvas>
          </div>

          <div class="chart-container four-chart" v-if="selectedMetrics.includes('longShort')">
            <canvas :id="mexcFourChartIds[index - 1]" :key="mexcFourChartIds[index - 1]"
              :ref="'mexc-four-chart' + (index - 1)"></canvas>
          </div>
        </div>
      </div>

      <!-- Bybit Chart Group -->
      <div v-for="index in totalChart" :key="'chart-grid-bybit-' + index" class="chart-grid bybit-chart-group">
        <div class="chart-header text-center">
          <h3>
            Biểu đồ Bybit -
            {{
              typeof arrayCoin[index - 1] === "object"
                ? arrayCoin[index - 1]?.coinName
                : arrayCoin[index - 1]
            }}
            <span class="exchange-badge-inline">BYBIT</span>
          </h3>
        </div>

        <div class="chart-box">
          <div class="chart-container first-chart" v-if="selectedMetrics.includes('openInterest')">
            <canvas :id="bybitChartIds[index - 1]" :key="bybitChartIds[index - 1]"
              :ref="'bybit-chart' + (index - 1)"></canvas>
          </div>

          <div class="chart-container second-chart" v-if="selectedMetrics.includes('longShort')">
            <canvas :id="bybitSecondChartIds[index - 1]" :key="bybitSecondChartIds[index - 1]"
              :ref="'bybit-second-chart' + (index - 1)"></canvas>
          </div>

          <div class="chart-container third-chart" v-if="selectedMetrics.includes('longShort')">
            <canvas :id="bybitThirdChartIds[index - 1]" :key="bybitThirdChartIds[index - 1]"
              :ref="'bybit-third-chart' + (index - 1)"></canvas>
          </div>
        </div>
      </div>
    </template>
  </div>
</template>

<script>
import { API_URL } from "../config";
import {
  Chart as ChartJS,
  CategoryScale,
  TimeScale,
  BarController,
  BarElement,
  LinearScale,
  LineElement,
  PointElement,
  LineController,
  Title,
  Tooltip,
  Legend,
  Filler,
  SubTitle,
} from "chart.js";
import "chartjs-adapter-date-fns";
import '@/assets/css/allcoins.css'
import "vue-select/dist/vue-select.css";
import ChartDataLabels from "chartjs-plugin-datalabels";
import MenuAllCoins from "./favorite/MenuAllCoins.vue";
ChartJS.register(
  CategoryScale,
  SubTitle,
  TimeScale,
  BarController,
  BarElement,
  LinearScale,
  LineElement,
  PointElement,
  LineController,
  ChartDataLabels,
  Title,
  Tooltip,
  Legend,
  Filler
);
const nfComma = new Intl.NumberFormat('en-US');
function fmtComma(n, frac = 0) {
  if (!Number.isFinite(n)) return '-';
  return nfComma.format(frac ? Number(n).toFixed(frac) : Math.round(n));
}
function niceMinMax(arr, pad = 0.06) {
  const vals = (arr || []).filter(Number.isFinite);
  if (!vals.length) return { min: 0, max: 1 };
  let min = Math.min(...vals);
  let max = Math.max(...vals);
  if (min === max) {
    const bump = Math.abs(min) || 1;
    return { min: min - bump * pad, max: max + bump * pad };
  }
  const range = max - min;
  return { min: min - range * pad, max: max + range * pad };
}
const shadowLine = {
  id: 'shadowLine',
  afterDatasetsDraw(chart) {
    const { ctx, data } = chart
    const meta = chart.getDatasetMeta(1)
    if (!meta || !meta.dataset) return
    ctx.save()
    ctx.shadowColor = 'rgba(0,0,0,0.7)'
    ctx.shadowBlur = 6
    ctx.shadowOffsetY = 2
    ctx.lineWidth = 2
    ctx.strokeStyle = '#ffffff'
    ctx.beginPath()
    meta.dataset.draw(ctx, data)
    ctx.restore()
  }
}
const stripeBg = {
  id: 'stripeBgLight',
  beforeDraw(chart) {
    const y = chart.scales?.y;
    const area = chart.chartArea;
    if (!y || !y.ticks?.length || !area) return;

    const { ctx, chartArea: { left, right, top, bottom } } = chart;

    ctx.save();
    ctx.fillStyle = '#ffffff';
    ctx.fillRect(left, top, right - left, bottom - top);

    for (let i = 0; i < y.ticks.length - 1; i++) {
      if (i % 2 === 0) {
        const y1 = y.getPixelForTick(i);
        const y2 = y.getPixelForTick(i + 1);
        ctx.fillStyle = 'rgba(0,0,0,0.035)';
        ctx.fillRect(left, y2, right - left, y1 - y2);
      }
    }
    ctx.restore();
  }
};
ChartJS.register(shadowLine)
export default {
  name: "AllCoins",
  components: {
    MenuAllCoins
  },
  data() {
    return {
      selectedCoin: null,
      chartIds: Array.from({ length: 30 }, (_, i) => `chart-${i}`),
      secondChartIds: Array.from({ length: 30 }, (_, i) => `second-chart-${i}`),
      thirdChartIds: Array.from({ length: 30 }, (_, i) => `third-chart-${i}`),
      fourChartIds: Array.from({ length: 30 }, (_, i) => `four-chart-${i}`),
      fiveChartIds: Array.from({ length: 30 }, (_, i) => `five-chart-${i}`),
      sixChartIds: Array.from({ length: 30 }, (_, i) => `six-chart-${i}`),
      sevenChartIds: Array.from({ length: 30 }, (_, i) => `seven-chart-${i}`),
      // MEXC chart IDs
      mexcChartIds: Array.from({ length: 30 }, (_, i) => `mexc-chart-${i}`),
      mexcSecondChartIds: Array.from({ length: 30 }, (_, i) => `mexc-second-chart-${i}`),
      mexcThirdChartIds: Array.from({ length: 30 }, (_, i) => `mexc-third-chart-${i}`),
      mexcFourChartIds: Array.from({ length: 30 }, (_, i) => `mexc-four-chart-${i}`),
      // Bybit chart IDs
      bybitChartIds: Array.from({ length: 30 }, (_, i) => `bybit-chart-${i}`),
      bybitSecondChartIds: Array.from({ length: 30 }, (_, i) => `bybit-second-chart-${i}`),
      bybitThirdChartIds: Array.from({ length: 30 }, (_, i) => `bybit-third-chart-${i}`),
      coinNames: Array(20).fill(""),
      periods: "",
      selectedMetrics: ['openInterest', 'longShort', 'inflow30d', 'inflow24h', 'fundingRate'],
      inflowDays: 30,
      charts: [],
      secondCharts: [],
      thirdCharts: [],
      fourCharts: [],
      fiveCharts: [],
      sixCharts: [],
      sevenCharts: [],
      chartDataSets: [],
      secondChartDataSets: [],
      thirdChartDataSets: [],
      fourChartDataSets: [],
      fiveChartDataSets: [],
      sixChartDataSets: [],
      sevenChartDataSets: [],
      // MEXC charts and datasets
      mexcCharts: [],
      mexcSecondCharts: [],
      mexcThirdCharts: [],
      mexcFourCharts: [],
      mexcChartDataSets: [],
      mexcSecondChartDataSets: [],
      mexcThirdChartDataSets: [],
      mexcFourChartDataSets: [],
      // Bybit charts and datasets
      bybitCharts: [],
      bybitSecondCharts: [],
      bybitThirdCharts: [],
      bybitChartDataSets: [],
      bybitSecondChartDataSets: [],
      bybitThirdChartDataSets: [],
      loading: false,
      coins: [],
      totalChart: 0,
      arrayCoin: [],
      displayedCoins: [],
      exceptionSymbols: new Set(["1000CAT", "1000CATUSDT", "1000CHEEMS", "1000CHEEMSUSDT", "1000SATS", "1000SATSUSDT"]),
      coinMetricsData: {} // Lưu marketcap và fdv cho từng coin
    };
  },
  async created() {
    await this.fetchCoins();
  },
  methods: {
    getCoinName(coinItem) {
      if (typeof coinItem === "string") {
        return coinItem;
      }
      return coinItem?.coinName || "BTC";
    },

    getCoinMetrics(coinItem) {
      const coinName = this.getCoinName(coinItem).replace("USDT", "");
      return this.coinMetricsData[coinName] || { marketcap: null, fdv: null, volMktCapPercent: null, oiMktCapPercent: null, cmcUrl: null };
    },

    formatCurrency(value) {
      if (!Number.isFinite(value)) return '-';
      const abs = Math.abs(value);
      if (abs >= 1e12) return (value / 1e12).toFixed(2) + 'T';
      if (abs >= 1e9) return (value / 1e9).toFixed(2) + 'B';
      if (abs >= 1e6) return (value / 1e6).toFixed(2) + 'M';
      if (abs >= 1e3) return (value / 1e3).toFixed(2) + 'K';
      return value.toFixed(2);
    },

    getLiquidationHeatmapUrl(coinItem) {
      const coinName = this.getCoinName(coinItem).replace("USDT", "");
      return `https://www.coinglass.com/pro/futures/LiquidationHeatMap?coin=${coinName}&type=symbol`;
    },

    normalizeCoinName(coinName) {
      if (!coinName) return "";
      const upper = coinName.toUpperCase();
      if (upper === "1000CAT" || upper === "1000CATUSDT") {
        return coinName;
      }
      if (this.exceptionSymbols.has(coinName)) {
        return coinName;
      }
      return coinName.replace(/^\d+/, '');
    },
    async fetchCoins() {
      try {
        const response = await fetch(`${API_URL}/binance/get-coins`);
        const data = await response.json();
        this.coins = data.map((coin) => ({
          id: coin.id,
          coinName: `${coin.coinName}USDT`,
          favoriteFlag: coin.favoriteFlag,
        }));
        const allCoins = this.coins
          .map((coin) => ({ ...coin, isSelected: coin.favoriteFlag === "1" }))
          .sort((a, b) => b.isSelected - a.isSelected);
        this.coinNames = allCoins
          .slice(0, 20)
          .map((coin) => (coin.isSelected ? coin.coinName : ""));
        this.coinNames = [
          ...this.coinNames,
          ...Array(20 - this.coinNames.length).fill(""),
        ];
        this.displayedCoins = allCoins.slice(0, 20);
      } catch (error) {
        console.error("Error fetching coins:", error);
      }
    },

    async fetchCoinMetrics(coinName) {
      try {
        // Bỏ "USDT" suffix để gửi lên API
        const cleanCoinName = coinName.replace("USDT", "");

        const response = await fetch(`${API_URL}/binance/get-mkc-fdm`, {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify([cleanCoinName]),
        });

        if (!response.ok) {
          throw new Error(`HTTP error! Status: ${response.status}`);
        }

        const data = await response.json();

        // Lưu dữ liệu vào coinMetricsData
        if (data && data.length > 0) {
          this.coinMetricsData[cleanCoinName] = {
            marketcap: data[0].marketcap,
            fdv: data[0].fdv,
            volMktCapPercent: data[0].volMktCapPercent,
            oiMktCapPercent: data[0].oiMktCapPercent,
            cmcUrl: data[0].cmcUrl,
          };
        }

        console.log(`Coin metrics fetched for ${cleanCoinName}:`, this.coinMetricsData[cleanCoinName]);
      } catch (error) {
        console.error(`Error fetching coin metrics for ${coinName}:`, error?.message || error);
      }
    },

    async handleSearch(payload) {
      const period = payload?.period || payload;
      const coin = payload?.coin;
      this.periods = period
      if (this.periods == "") {
        this.$toast.open({
          message: 'Vui lòng chọn thời gian!',
          type: 'error',
          position: 'top-right',
        });
        return false
      }
      if (!this.selectedMetrics.length) {
        this.totalChart = 0;
        this.arrayCoin = [];
        this.charts = []; this.secondCharts = []; this.thirdCharts = [];
        this.fourCharts = []; this.sevenCharts = [];
        return;
      }

      // AllCoins chỉ cho phép chọn 1 coin, nên phải có coin được chọn
      if (!coin || !coin.coinName) {
        this.$toast.open({
          message: 'Vui lòng chọn một coin!',
          type: 'error',
          position: 'top-right',
        });
        this.totalChart = 0;
        this.arrayCoin = [];
        this.charts = []; this.secondCharts = []; this.thirdCharts = [];
        this.fourCharts = []; this.sevenCharts = [];
        return false;
      }

      const loading = this.$loading.show();

      // Chỉ hiển thị coin được chọn
      let filteredArray = [coin.coinName];
      this.coinNames = filteredArray;

      // Lấy dữ liệu marketcap và fdv
      await this.fetchCoinMetrics(coin.coinName);

      for (let i = 0; i < filteredArray.length; i++) {
        this.loading = true;
        const jobs = [];
        const sel = new Set(this.selectedMetrics);

        // Binance API calls
        if (sel.has('openInterest')) jobs.push(this.fetchNotionalData(this.coinNames[i], i, this.periods));
        if (sel.has('longShort')) {
          jobs.push(
            this.fetchSecondApiDataForCoin(this.coinNames[i], i, this.periods),
            this.fetchThirdApiDataForCoin(this.coinNames[i], i, this.periods),
            this.fetchFourApiDataForCoin(this.coinNames[i], i, this.periods)
          );
        }
        if (sel.has('inflow30d')) jobs.push(this.fetchFiveApiDataForCoin(this.coinNames[i], i));
        if (sel.has('inflow24h')) jobs.push(this.fetchSixApiDataForCoin(this.coinNames[i], i));
        if (sel.has('fundingRate')) jobs.push(this.fetchSevenApiDataForCoin(this.coinNames[i], i));

        // MEXC API calls
        if (sel.has('openInterest')) jobs.push(this.fetchMexcOpenInterest(this.coinNames[i], i, this.periods));
        if (sel.has('longShort')) {
          jobs.push(
            this.fetchMexcLongShortAcc(this.coinNames[i], i, this.periods),
            this.fetchMexcLongShortPoss(this.coinNames[i], i, this.periods),
            this.fetchMexcLongShort(this.coinNames[i], i, this.periods)
          );
        }

        // Bybit API calls
        if (sel.has('openInterest')) jobs.push(this.fetchBybitOpenInterest(this.coinNames[i], i, this.periods));
        if (sel.has('longShort')) {
          jobs.push(
            this.fetchBybitLongShortAcc(this.coinNames[i], i, this.periods),
            this.fetchBybitLongShortPoss(this.coinNames[i], i, this.periods)
          );
        }

        await Promise.all(jobs);
      }
      this.totalChart = filteredArray.length;
      this.loading = false;
      this.arrayCoin = this.coinNames;
      this.createCharts();
      loading.hide();
    },

    async fetchNotionalData(coinName, index, period) {
      try {
        const requestBody = {
          name: `${coinName}USDT`,
          periodMinutes: period,
        };

        const res = await fetch(`${API_URL}/binance/open-interest`, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify(requestBody),
        });

        if (!res.ok) {
          const text = await res.text().catch(() => '');
          throw new Error(`HTTP ${res.status} ${res.statusText} - ${text}`);
        }

        const raw = await res.json();
        const list =
          Array.isArray(raw) ? raw
            : Array.isArray(raw?.data) ? raw.data
              : Array.isArray(raw?.data?.list) ? raw.data.list
                : [];

        if (!Array.isArray(list) || list.length === 0) {
          console.warn('Payload rỗng hoặc sai định dạng:', raw);
          this.chartDataSets[index] = [];
          return;
        }
        const sorted = [...list].sort((a, b) => Number(a.timestamp) - Number(b.timestamp));
        const last = sorted.slice(-30);
        const result = last.map(item => ({
          x: Number(item.timestamp),
          oi: Number(item.sumOpenInterest),
          notional: Number(item.sumOpenInterestValue),
        }));

        this.chartDataSets[index] = result;
      } catch (error) {
        console.error(`Lỗi khi tải dữ liệu từ API mới cho ${coinName}:`, error?.message || error);
        this.chartDataSets[index] = [];
      }
    },

    async fetchSecondApiDataForCoin(coinName, index, period) {
      try {
        const requestBody = {
          symbol: `${coinName}USDT`,
          period: period,
          limit: 30,
        };

        const response = await fetch(
          `${API_URL}/binance/longshort-acc`,
          {
            method: "POST",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify(requestBody),
          }
        );

        if (!response.ok) {
          throw new Error(`HTTP error! Status: ${response.status}`);
        }

        const data = await response.json();
        const result = data
          .map((item) => {
            if (item.timeGet) {
              return {
                x: item.timeGet,
                y: parseFloat(parseFloat(item.longShortRatio || 0).toFixed(3)),
                longPercent: parseFloat(item.longPercent),
                shortPercent: parseFloat(item.shortPercent),
                longShortRatio: parseFloat(parseFloat(item.longShortRatio || 0).toFixed(3)),
              };
            }
            return null;
          })
          .filter((item) => item !== null);
        this.secondChartDataSets[index] = result;
      } catch (error) {
        console.error(
          `Lỗi khi tải dữ liệu từ API mới cho ${coinName}:`,
          error.message || error
        );
      }
    },

    async fetchThirdApiDataForCoin(coinName, index, period) {
      try {
        const requestBody = {
          symbol: `${coinName}USDT`,
          period: period,
          limit: 30,
        };

        const response = await fetch(
          `${API_URL}/binance/longshort-poss`,
          {
            method: "POST",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify(requestBody),
          }
        );

        if (!response.ok) {
          throw new Error(`HTTP error! Status: ${response.status}`);
        }

        const data = await response.json();
        const result = data
          .map((item) => {
            if (item.timeGet) {
              return {
                x: item.timeGet,
                y: parseFloat(parseFloat(item.longShortRatio || 0).toFixed(3)),
                longPercent: parseFloat(item.longPercent),
                shortPercent: parseFloat(item.shortPercent),
                longShortRatio: parseFloat(parseFloat(item.longShortRatio || 0).toFixed(3)),
              };
            }
            return null;
          })
          .filter((item) => item !== null);

        this.thirdChartDataSets[index] = result;
      } catch (error) {
        console.error(
          `Lỗi khi tải dữ liệu từ API thứ ba cho ${coinName}:`,
          error.message || error
        );
      }
    },
    async fetchFourApiDataForCoin(coinName, index, period) {
      try {
        const requestBody = {
          symbol: `${coinName}USDT`,
          period: period,
          limit: 30,
        };

        const response = await fetch(`${API_URL}/binance/longshort`, {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify(requestBody),
        });

        if (!response.ok) {
          throw new Error(`HTTP error! Status: ${response.status}`);
        }

        const data = await response.json();
        const result = data
          .map((item) => {
            if (item.timeGet) {
              return {
                x: item.timeGet,
                y: parseFloat(parseFloat(item.longShortRatio || 0).toFixed(3)),
                longPercent: parseFloat(item.longPercent),
                shortPercent: parseFloat(item.shortPercent),
                longShortRatio: parseFloat(parseFloat(item.longShortRatio || 0).toFixed(3)),
              };
            }
            return null;
          })
          .filter((item) => item !== null);

        this.fourChartDataSets[index] = result;
      } catch (error) {
        console.error(
          `Lỗi khi tải dữ liệu từ API thứ ba cho ${coinName}:`,
          error.message || error
        );
      }
    },
    async fetchFiveApiDataForCoin(coinName, index) {
      try {
        const requestBody = {
          symbol: `${coinName}USDT`,
          groupCount: '7',
          groupSize: '24',
          period: 'HOUR_1',
          volumeType: 'BIG',
          targetDays: this.inflowDays,
        };

        const res = await fetch(`${API_URL}/binance/day-large-inflow`, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify(requestBody),
        });

        if (!res.ok) {
          const t = await res.text().catch(() => '');
          throw new Error(`HTTP ${res.status} ${res.statusText} - ${t}`);
        }

        const raw = await res.json();
        const data = raw?.data ?? raw;
        const list = Array.isArray(data?.netCapitalInList) ? data.netCapitalInList : [];

        // De-duplicate items by date (newest/first duplicate is kept because list is newest-first)
        const seenDates = new Set();
        const uniqueList = [];
        for (const it of list) {
          const d = new Date(it.startTime || Date.now());
          const day = String(d.getDate()).padStart(2, '0');
          const month = String(d.getMonth() + 1).padStart(2, '0');
          const dateStr = `${day}/${month}`;
          if (!seenDates.has(dateStr)) {
            seenDates.add(dateStr);
            uniqueList.push(it);
          }
        }

        let series = uniqueList
          .map(it => Number.parseFloat(it?.netCapitalInflowVolume ?? 0))
          .filter(Number.isFinite);

        // Tạo mảng nhãn ngày (DD/MM) từ startTime
        const dates = uniqueList.map((it) => {
          const d = new Date(it.startTime || Date.now());
          const day = String(d.getDate()).padStart(2, '0');
          const month = String(d.getMonth() + 1).padStart(2, '0');
          return `${day}/${month}`;
        });

        let finalDates = dates;
        if (series.length > this.inflowDays) {
          series = series.slice(0, this.inflowDays);
          finalDates = finalDates.slice(0, this.inflowDays);
        } else if (series.length < this.inflowDays) {
          const missingCount = this.inflowDays - series.length;
          
          // Pad series with 0 at the END (oldest values)
          series = series.concat(Array(missingCount).fill(0));
          
          // Pad finalDates with successive older days at the END (oldest values)
          const paddedDates = [];
          const oldestTime = uniqueList.length > 0 ? (uniqueList[uniqueList.length - 1].startTime || Date.now()) : Date.now();
          for (let i = 1; i <= missingCount; i++) {
            const d = new Date(oldestTime - i * 86400000);
            const day = String(d.getDate()).padStart(2, '0');
            const month = String(d.getMonth() + 1).padStart(2, '0');
            paddedDates.push(`${day}/${month}`);
          }
          finalDates = finalDates.concat(paddedDates);
        }

        const totalInFlowNum = Number.parseFloat(data?.totalInFlow);
        const totalInFlow = Number.isFinite(totalInFlowNum) ? totalInFlowNum : 0;
        const totalInFlowUsdtNum = Number.parseFloat(data?.totalInFlowUsdt);
        const totalInFlowUsdt = Number.isFinite(totalInFlowUsdtNum) ? totalInFlowUsdtNum : 0;
        if (!Array.isArray(this.fiveChartDataSets)) this.fiveChartDataSets = [];

        this.fiveChartDataSets[index] = {
          dataSet: series,
          totalInFlow,
          totalInFlowUsdt,
          dates: finalDates,
        };
      } catch (error) {
        console.error(`Lỗi khi tải dữ liệu từ API thứ ba cho ${coinName}:`, error?.message || error);
        if (!Array.isArray(this.fiveChartDataSets)) this.fiveChartDataSets = [];
        this.fiveChartDataSets[index] = {
          dataSet: Array(this.inflowDays).fill(0),
          totalInFlow: 0,
          totalInFlowUsdt: 0,
        };
      }
    },

    async fetchSixApiDataForCoin(coinName, index) {
      try {
        const requestBody = {
          symbol: `${coinName}USDT`,
          intervalEnum: "FIVE_MINUTES",
          size: "288",
        };

        const response = await fetch(`${API_URL}/binance/24hour-large-inflow`, {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify(requestBody),
        });

        const data = await response.json();
        const result = data.data
          .map((item) => {
            if (item.startTime) {
              return {
                x: item.startTime,
                y: parseFloat(item.netCapitalInflowVolume),
              };
            }
            return null;
          })
          .filter((item) => item !== null);
        this.sixChartDataSets[index] = result;

      } catch (error) {
        this.sixChartDataSets[index] = [];
        console.error(
          `Lỗi khi tải dữ liệu từ API thứ ba cho ${coinName}:`,
          error.message || error
        );
      }
    },
    async fetchSevenApiDataForCoin(coinName, index) {
      try {
        const requestBody = {
          symbol: `${coinName}USDT`,
          period: this.periods
        };

        const response = await fetch(`${API_URL}/binance/get-funding-rate`, {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify(requestBody),
        });

        if (!response.ok) {
          throw new Error(`HTTP ${response.status} ${response.statusText}`);
        }

        const raw = await response.json();
        const list = Array.isArray(raw) ? raw : (Array.isArray(raw?.data) ? raw.data : []);

        const result = list
          .map(it => {
            const t = new Date(it.syncTime).getTime();
            const y = parseFloat(it.fundingRate);
            if (!Number.isFinite(t) || !Number.isFinite(y)) return null;
            return { x: t, y };
          })
          .filter(Boolean)
          .sort((a, b) => a.x - b.x);
        this.sevenChartDataSets[index] = result;

      } catch (error) {
        this.sevenChartDataSets[index] = [];
        console.error(
          `Lỗi khi tải dữ liệu từ API thứ ba cho ${coinName}:`,
          error.message || error
        );
      }
    },

    // MEXC API fetch methods
    async fetchMexcOpenInterest(coinName, index, period) {
      try {
        // Thêm USDT vào sau symbol nếu chưa có
        const symbol = coinName.toUpperCase().endsWith('USDT') ? coinName : `${coinName}USDT`;

        const requestBody = {
          name: symbol,
          periodMinutes: period,
        };

        const res = await fetch(`${API_URL}/mexc/open-interest`, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify(requestBody),
        });

        if (!res.ok) {
          const text = await res.text().catch(() => '');
          throw new Error(`HTTP ${res.status} ${res.statusText} - ${text}`);
        }

        const raw = await res.json();
        const list =
          Array.isArray(raw) ? raw
            : Array.isArray(raw?.data) ? raw.data
              : Array.isArray(raw?.data?.list) ? raw.data.list
                : [];

        if (!Array.isArray(list) || list.length === 0) {
          console.warn('MEXC Open Interest: Payload rỗng hoặc sai định dạng:', raw);
          this.mexcChartDataSets[index] = [];
          return;
        }

        const sorted = [...list].sort((a, b) => Number(a.timestamp) - Number(b.timestamp));
        const last = sorted.slice(-30);
        const result = last.map(item => ({
          x: Number(item.timestamp),
          oi: Number(item.sumOpenInterest),
          notional: Number(item.sumOpenInterestValue),
        }));

        this.mexcChartDataSets[index] = result;
      } catch (error) {
        console.error(`Lỗi khi tải dữ liệu MEXC Open Interest cho ${coinName}:`, error?.message || error);
        this.mexcChartDataSets[index] = [];
      }
    },

    async fetchMexcLongShortAcc(coinName, index, period) {
      try {
        // Thêm USDT vào sau symbol nếu chưa có
        const symbol = coinName.toUpperCase().endsWith('USDT') ? coinName : `${coinName}USDT`;

        const requestBody = {
          symbol: symbol,
          period: period,
          limit: 30,
        };

        const response = await fetch(`${API_URL}/mexc/longshort-acc`, {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify(requestBody),
        });

        if (!response.ok) {
          throw new Error(`HTTP error! Status: ${response.status}`);
        }

        const data = await response.json();
        const result = data
          .map((item) => {
            if (item.timeGet) {
              return {
                x: item.timeGet,
                y: parseFloat(parseFloat(item.longShortRatio || 0).toFixed(3)),
                longPercent: parseFloat(item.longPercent),
                shortPercent: parseFloat(item.shortPercent),
                longShortRatio: parseFloat(parseFloat(item.longShortRatio || 0).toFixed(3)),
              };
            }
            return null;
          })
          .filter((item) => item !== null);
        this.mexcSecondChartDataSets[index] = result;
      } catch (error) {
        console.error(`Lỗi khi tải dữ liệu MEXC Long/Short Acc cho ${coinName}:`, error.message || error);
        this.mexcSecondChartDataSets[index] = [];
      }
    },

    async fetchMexcLongShortPoss(coinName, index, period) {
      try {
        // Thêm USDT vào sau symbol nếu chưa có
        const symbol = coinName.toUpperCase().endsWith('USDT') ? coinName : `${coinName}USDT`;

        const requestBody = {
          symbol: symbol,
          period: period,
          limit: 30,
        };

        const response = await fetch(`${API_URL}/mexc/longshort-poss`, {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify(requestBody),
        });

        if (!response.ok) {
          throw new Error(`HTTP error! Status: ${response.status}`);
        }

        const data = await response.json();
        const result = data
          .map((item) => {
            if (item.timeGet) {
              return {
                x: item.timeGet,
                y: parseFloat(parseFloat(item.longShortRatio || 0).toFixed(3)),
                longPercent: parseFloat(item.longPercent),
                shortPercent: parseFloat(item.shortPercent),
                longShortRatio: parseFloat(parseFloat(item.longShortRatio || 0).toFixed(3)),
              };
            }
            return null;
          })
          .filter((item) => item !== null);

        this.mexcThirdChartDataSets[index] = result;
      } catch (error) {
        console.error(`Lỗi khi tải dữ liệu MEXC Long/Short Poss cho ${coinName}:`, error.message || error);
        this.mexcThirdChartDataSets[index] = [];
      }
    },

    async fetchMexcLongShort(coinName, index, period) {
      try {
        // Thêm USDT vào sau symbol nếu chưa có
        const symbol = coinName.toUpperCase().endsWith('USDT') ? coinName : `${coinName}USDT`;

        const requestBody = {
          symbol: symbol,
          period: period,
          limit: 30,
        };

        const response = await fetch(`${API_URL}/mexc/longshort`, {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify(requestBody),
        });

        if (!response.ok) {
          throw new Error(`HTTP error! Status: ${response.status}`);
        }

        const data = await response.json();
        const result = data
          .map((item) => {
            if (item.timeGet) {
              return {
                x: item.timeGet,
                y: parseFloat(parseFloat(item.longShortRatio || 0).toFixed(3)),
                longPercent: parseFloat(item.longPercent),
                shortPercent: parseFloat(item.shortPercent),
                longShortRatio: parseFloat(parseFloat(item.longShortRatio || 0).toFixed(3)),
              };
            }
            return null;
          })
          .filter((item) => item !== null);

        this.mexcFourChartDataSets[index] = result;
      } catch (error) {
        console.error(`Lỗi khi tải dữ liệu MEXC Long/Short cho ${coinName}:`, error.message || error);
        this.mexcFourChartDataSets[index] = [];
      }
    },

    // Bybit API fetch methods
    async fetchBybitOpenInterest(coinName, index, period) {
      try {
        // Thêm USDT vào sau symbol nếu chưa có
        const symbol = coinName.toUpperCase().endsWith('USDT') ? coinName : `${coinName}USDT`;

        const requestBody = {
          name: symbol,
          periodMinutes: period,
        };

        const res = await fetch(`${API_URL}/bybit/open-interest`, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify(requestBody),
        });

        if (!res.ok) {
          const text = await res.text().catch(() => '');
          throw new Error(`HTTP ${res.status} ${res.statusText} - ${text}`);
        }

        const raw = await res.json();
        const list = raw?.result?.tradingMetricsList || [];

        if (!Array.isArray(list) || list.length === 0) {
          console.warn('Bybit Open Interest: Payload rỗng hoặc sai định dạng:', raw);
          this.bybitChartDataSets[index] = [];
          return;
        }

        const sorted = [...list].sort((a, b) => Number(a.timestamp) - Number(b.timestamp));
        const result = sorted.map(item => ({
          x: Number(item.timestamp),
          oi: Number(item.oi),
          notional: Number(item.oiInUSDT),
        }));

        this.bybitChartDataSets[index] = result;
      } catch (error) {
        console.error(`Lỗi khi tải dữ liệu Bybit Open Interest cho ${coinName}:`, error?.message || error);
        this.bybitChartDataSets[index] = [];
      }
    },

    async fetchBybitLongShortAcc(coinName, index, period) {
      try {
        // Thêm USDT vào sau symbol nếu chưa có
        const symbol = coinName.toUpperCase().endsWith('USDT') ? coinName : `${coinName}USDT`;

        const requestBody = {
          symbol: symbol,
          period: period,
          limit: 30,
        };

        const response = await fetch(`${API_URL}/bybit/longshort-acc`, {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify(requestBody),
        });

        if (!response.ok) {
          throw new Error(`HTTP error! Status: ${response.status}`);
        }

        const raw = await response.json();
        const list = raw?.result?.holderPosList || [];

        if (!Array.isArray(list) || list.length === 0) {
          console.warn('Bybit Long/Short Acc: Payload rỗng hoặc sai định dạng:', raw);
          this.bybitSecondChartDataSets[index] = [];
          return;
        }

        const sorted = [...list].sort((a, b) => Number(a.timestamp) - Number(b.timestamp));
        const result = sorted.map((item) => ({
          x: Number(item.timestamp),
          y: parseFloat(parseFloat(item.longShortRatio || 0).toFixed(3)),
          longPercent: parseFloat(item.longPosRatio) * 100,
          shortPercent: parseFloat(item.shortPosRatio) * 100,
          longShortRatio: parseFloat(parseFloat(item.longShortRatio || 0).toFixed(3)),
        }));

        this.bybitSecondChartDataSets[index] = result;
      } catch (error) {
        console.error(`Lỗi khi tải dữ liệu Bybit Long/Short Acc cho ${coinName}:`, error.message || error);
        this.bybitSecondChartDataSets[index] = [];
      }
    },

    async fetchBybitLongShortPoss(coinName, index, period) {
      try {
        // Thêm USDT vào sau symbol nếu chưa có
        const symbol = coinName.toUpperCase().endsWith('USDT') ? coinName : `${coinName}USDT`;

        const requestBody = {
          symbol: symbol,
          period: period,
          limit: 30,
        };

        const response = await fetch(`${API_URL}/bybit/longshort-poss`, {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify(requestBody),
        });

        if (!response.ok) {
          throw new Error(`HTTP error! Status: ${response.status}`);
        }

        const raw = await response.json();
        const list = raw?.result?.topHolderPosList || raw?.result?.holderPosList || [];

        if (!Array.isArray(list) || list.length === 0) {
          console.warn('Bybit Long/Short Poss: Payload rỗng hoặc sai định dạng:', raw);
          this.bybitThirdChartDataSets[index] = [];
          return;
        }

        const sorted = [...list].sort((a, b) => Number(a.timestamp) - Number(b.timestamp));
        const result = sorted.map((item) => ({
          x: Number(item.timestamp),
          y: parseFloat(parseFloat(item.longShortRatio || 0).toFixed(3)),
          longPercent: parseFloat(item.longPosRatio) * 100,
          shortPercent: parseFloat(item.shortPosRatio) * 100,
          longShortRatio: parseFloat(parseFloat(item.longShortRatio || 0).toFixed(3)),
        }));

        this.bybitThirdChartDataSets[index] = result;
      } catch (error) {
        console.error(`Lỗi khi tải dữ liệu Bybit Long/Short Poss cho ${coinName}:`, error.message || error);
        this.bybitThirdChartDataSets[index] = [];
      }
    },

    createCharts() {
      this.$nextTick(() => {
        requestAnimationFrame(() => {
          const kill = c => { try { c && !c._destroyed && c.destroy(); } catch (_) { /* ignore */ } };
          [this.charts, this.secondCharts, this.thirdCharts, this.fourCharts, this.fiveCharts, this.sixCharts, this.sevenCharts,
          this.mexcCharts, this.mexcSecondCharts, this.mexcThirdCharts, this.mexcFourCharts,
          this.bybitCharts, this.bybitSecondCharts, this.bybitThirdCharts]
            .forEach(arr => {
              (arr || []).forEach((c, i) => {
                const cv = c?.canvas;
                if (!cv || !document.body.contains(cv)) { kill(c); arr[i] = null; }
              });
            });
          let periods = this.periods;
          this.chartIds.slice(0, this.totalChart).forEach((chartId, index) => {
            const canvas = document.getElementById(chartId);
            if (canvas) {
              if (!canvas) return;
              if (canvas.offsetParent === null) return;
              const exist = ChartJS.getChart(canvas);
              if (exist) {
                try { exist.destroy(); } catch (e) {
                  // skip
                }
              }
              const ctx = canvas.getContext("2d");
              if (!ctx) return;
              if (this.charts[index]) {
                try { this.charts[index].destroy(); } catch (e) {
                  // skip
                }
                this.charts[index] = null;
              }
              const dataSet = this.chartDataSets[index] || [];
              const labels = dataSet.map(item => item.x);
              const oi = dataSet.map(item => item.oi);
              const notional = dataSet.map(item => item.notional);

              const yL = niceMinMax(oi, 0.06);
              const yR = niceMinMax(notional, 0.06);
              const LEFT_TICKS = 4;
              const RIGHT_TICKS = 4;
              const leftStep = (yL.max - yL.min) / Math.max(1, LEFT_TICKS - 1);
              const rightStep = (yR.max - yR.min) / Math.max(1, RIGHT_TICKS - 1);

              this.charts[index] = new ChartJS(ctx, {
                type: "bar",
                data: {
                  labels,
                  datasets: [
                    {
                      type: 'bar',
                      label: `Open Interest (${this.coinNames[index]?.replace('USDT', '') || 'BTC'})`,
                      data: oi,
                      yAxisID: 'y',
                      backgroundColor: '#f0b90b',
                      borderColor: '#dca600',
                      borderSkipped: false,
                      borderWidth: 0,
                      borderRadius: 2,
                      barPercentage: 0.6,
                      categoryPercentage: 0.8,
                      maxBarThickness: 12,
                      datalabels: { display: false },
                      order: 1
                    },
                    {
                      type: 'line',
                      label: 'Notional Value of Open Interest (USDT)',
                      data: notional,
                      yAxisID: 'y1',
                      borderColor: '#ffffff',
                      borderWidth: 2,
                      order: 999,
                      z: 10,
                      showLine: true,
                      spanGaps: true,
                      pointRadius: 2,
                      pointHoverRadius: 3,
                      pointBackgroundColor: '#0b1220',
                      pointBorderColor: '#e5e7eb',
                      pointBorderWidth: 1,
                      tension: 0.25,
                      cubicInterpolationMode: 'monotone',
                      fill: false,
                      datalabels: { display: false }
                    }
                  ],
                },
                options: {
                  responsive: true,
                  maintainAspectRatio: false,
                  layout: { padding: 0 },
                  interaction: {
                    mode: 'index',
                    intersect: false
                  },
                  plugins: {
                    legend: {
                      display: true,
                      reverse: false
                    },
                    datalabels: {
                      display: false,
                    },
                    title: {
                      display: true,
                      text: `Open Interest(${this.coinNames[index]})`,
                    },
                    tooltip: {
                      backgroundColor: '#111827',
                      borderColor: '#374151',
                      borderWidth: 1,
                      titleColor: '#e5e7eb',
                      bodyColor: '#e5e7eb',
                      callbacks: {
                        title(items) {
                          const ts = items[0]?.parsed.x;
                          return ts ? new Date(ts).toLocaleTimeString() : '';
                        },
                        label(c) {
                          const name = c.dataset.label;
                          const value = c.parsed.y;
                          return ` ${name}: ${fmtComma(value)}`;
                        }
                      }
                    },
                  },
                  scales: {
                    x: {
                      type: 'time',
                      time: {
                        unit: this.periods === "1h" || this.periods === "4h" ? "hour"
                          : this.periods === "1d" ? "day" : "minute"
                      },
                      grid: {
                        color: 'rgba(255,255,255,0.10)',
                        drawTicks: true,
                        drawOnChartArea: true
                      },
                      offset: false,
                      bounds: 'data',
                      ticks: {
                        color: '#9ca3af',
                        maxTicksLimit: 15,
                        count: 15,
                        autoSkip: true,
                        autoSkipPadding: 8,

                        maxRotation: 55,
                        minRotation: 35,
                        padding: 2,

                        callback: function (value) {
                          const date = new Date(value);
                          if (periods === "1d") {
                            return date.toLocaleDateString("en-GB", { day: "2-digit", month: "2-digit" });
                          } else {
                            return date.toLocaleTimeString("en-GB", { hour: "2-digit", minute: "2-digit" });
                          }
                        },
                      },
                    },
                    y: {
                      position: 'left',
                      min: yL.min,
                      max: yL.max,
                      beginAtZero: false,
                      grid: { color: 'rgba(255,255,255,0.10)', drawOnChartArea: true, drawTicks: true },
                      ticks: {
                        color: '#9ca3af', font: { size: 11 }, padding: 0, count: LEFT_TICKS, stepSize: leftStep,
                        callback: function (v) {
                          const a = Math.abs(v);
                          if (a >= 1e12) return (v / 1e12).toFixed(0) + 'T';
                          if (a >= 1e9) return (v / 1e9).toFixed(0) + 'B';
                          if (a >= 1e6) return (v / 1e6).toFixed(0) + 'M';
                          if (a >= 1e3) return (v / 1e3).toFixed(0) + 'K';
                          return Math.round(v);
                        }
                      },
                      title: { display: false }
                    },
                    y1: {
                      position: 'right',
                      min: yR.min,
                      max: yR.max,
                      beginAtZero: false,
                      grid: { display: false, drawOnChartArea: false },
                      ticks: {
                        color: '#9ca3af', font: { size: 11 }, padding: 0, count: RIGHT_TICKS, stepSize: rightStep,
                        callback: function (v) {
                          const a = Math.abs(v);
                          if (a >= 1e12) return (v / 1e12).toFixed(0) + 'T';
                          if (a >= 1e9) return (v / 1e9).toFixed(0) + 'B';
                          if (a >= 1e6) return (v / 1e6).toFixed(0) + 'M';
                          if (a >= 1e3) return (v / 1e3).toFixed(0) + 'K';
                          return Math.round(v);
                        }
                      },
                      title: { display: false }
                    }
                  }
                },
                plugins: [stripeBg]
              });
              if (canvas && canvas.parentNode) {
                canvas.parentNode.style.height = '300px';
              }
            }
          });

          this.secondChartIds
            .slice(0, this.totalChart)
            .forEach((chartId, index) => {
              const canvas = document.getElementById(chartId);
              if (!canvas) return;
              if (canvas.offsetParent === null) return;
              const exist = ChartJS.getChart(canvas);
              if (exist) {
                try { exist.destroy(); } catch (e) {
                  // skip
                }
              }
              const ctx = canvas.getContext("2d");
              if (!ctx) return;
              if (canvas) {
                if (this.secondCharts[index]) {
                  try { this.secondCharts[index].destroy(); } catch (e) {
                    // skip
                  }
                  this.secondCharts[index] = null;
                }

                const dataSet = this.secondChartDataSets[index] || [];
                const minValue = Math.min(
                  ...dataSet.map((item) => item.longShortRatio)
                );
                const roundedValue = Math.floor(minValue / 0.05) * 0.05;
                const startValue =
                  minValue - roundedValue <= 0.05
                    ? roundedValue
                    : roundedValue + 0.05;

                this.secondCharts[index] = new ChartJS(ctx, {
                  type: "bar",
                  data: {
                    datasets: [
                      {
                        label: "Tỷ lệ Long/Short",
                        type: "line",
                        data: dataSet,
                        borderColor: "rgba(0, 0, 0, 1)",
                        pointBackgroundColor: "rgba(255, 255, 255, 1)",
                        pointBorderColor: "rgba(0, 0, 0, 1)",
                        pointBorderWidth: 1.5,
                        pointRadius: 4,
                        pointHoverRadius: 6,
                        fill: true,
                        tension: 0.4,
                        borderWidth: 2,
                        yAxisID: "y-line",
                        meta: {
                          customValue: dataSet,
                        },
                      },
                      {
                        label: "% Tài khoản Long",
                        data: dataSet.map((item) => item.longPercent),
                        backgroundColor: "rgba(0, 209, 112, 0.8)",
                        stack: "Stack 0",
                        yAxisID: "y-bar",
                        meta: {
                          customValue: dataSet,
                        },
                      },
                      {
                        label: "% Tài khoản Short",
                        data: dataSet.map((item) => item.shortPercent),
                        backgroundColor: "rgba(231, 76, 60, 0.8)",
                        stack: "Stack 0",
                        yAxisID: "y-bar",
                        meta: {
                          customValue: dataSet,
                        },
                      },
                    ],
                  },
                  options: {
                    responsive: true,
                    maintainAspectRatio: false,
                    plugins: {
                      legend: {
                        display: true,
                      },
                      datalabels: {
                        display: false,
                      },
                      title: {
                        display: true,
                        text: `Top Accounts(${this.coinNames[index]})`,
                      },
                      tooltip: {
                        callbacks: {
                          label: function (tooltipItem) {
                            const dataset = tooltipItem.dataset;
                            const rawData = dataset.meta.customValue;
                            const index = tooltipItem.dataIndex;
                            const shortPercent = rawData[index].shortPercent || 0;
                            const longPercent = rawData[index].longPercent || 0;
                            const longShortRatio =
                              rawData[index].longShortRatio || 0;
                            return `Long: ${longPercent}%\r\nShort: ${shortPercent}%\r\nLong Short Ratio: ${Number(longShortRatio).toFixed(3)}`;
                          },
                        },
                      },
                    },
                    scales: {
                      x: {
                        type: "time",
                        time: {
                          ...(this.periods === "1d" && {
                            round: "day",
                          }),
                          unit:
                            this.periods === "1h" || this.periods === "4h"
                              ? "hour"
                              : this.periods === "1d"
                                ? "day"
                                : "minute",
                        },
                        labels: dataSet.map((item) => item.x),
                        ticks: {
                          maxTicksLimit: 20,
                          ...(this.periods !== "1d" && {
                            stepSize:
                              this.periods === "1h"
                                ? 1
                                : this.periods === "4h"
                                  ? 4
                                  : 5,
                          }),
                          callback: function (value) {
                            const date = new Date(value);
                            if (periods === "1d") {
                              return date.toLocaleDateString("en-GB", {
                                day: "2-digit",
                                month: "2-digit",
                              });
                            } else {
                              return date.toLocaleTimeString("en-GB", {
                                hour: "2-digit",
                                minute: "2-digit",
                              });
                            }
                          },
                        },
                        stacked: true,
                      },
                      "y-line": {
                        id: "y-line",
                        position: "right",
                        grid: {
                          drawOnChartArea: false,
                        },
                        beginAtZero: false,
                        min: startValue,
                        ticks: {
                          callback: function (value) {
                            return value.toFixed(2);
                          },
                        },
                      },
                      y: {
                        display: false,
                        grid: {
                          display: false,
                        },
                      },
                    },
                  },
                });
              }
            });

          this.thirdChartIds
            .slice(0, this.totalChart)
            .forEach((chartId, index) => {
              const canvas = document.getElementById(chartId);
              if (!canvas) return;
              if (canvas.offsetParent === null) return;
              const exist = ChartJS.getChart(canvas);
              if (exist) {
                try { exist.destroy(); } catch (e) {
                  // skip
                }
              }
              const ctx = canvas.getContext("2d");
              if (!ctx) return;
              if (canvas) {
                if (this.thirdCharts[index]) {
                  try { this.thirdCharts[index].destroy(); } catch (e) {
                    // skip
                  }
                  this.thirdCharts[index] = null;
                }

                const dataSet = this.thirdChartDataSets[index] || [];
                const minValue = Math.min(
                  ...dataSet.map((item) => item.longShortRatio)
                );
                const roundedValue = Math.floor(minValue / 0.05) * 0.05;
                const startValue =
                  minValue - roundedValue <= 0.05
                    ? roundedValue
                    : roundedValue + 0.05;

                this.thirdCharts[index] = new ChartJS(ctx, {
                  type: "bar",
                  data: {
                    datasets: [
                      {
                        label: "Tỷ lệ Long/Short",
                        type: "line",
                        data: dataSet,
                        borderColor: "rgba(0, 0, 0, 1)",
                        pointBackgroundColor: "rgba(255, 255, 255, 1)",
                        pointBorderColor: "rgba(0, 0, 0, 1)",
                        pointBorderWidth: 1.5,
                        pointRadius: 4,
                        pointHoverRadius: 6,
                        fill: true,
                        tension: 0.4,
                        borderWidth: 2,
                        yAxisID: "y-line",
                        meta: {
                          customValue: dataSet,
                        },
                      },
                      {
                        label: "% Vị thế Long",
                        data: dataSet.map((item) => item.longPercent),
                        backgroundColor: "rgba(0, 209, 112, 0.8)",
                        stack: "Stack 0",
                        yAxisID: "y-bar",
                        meta: {
                          customValue: dataSet,
                        },
                      },
                      {
                        label: "% Vị thế Short",
                        data: dataSet.map((item) => item.shortPercent),
                        backgroundColor: "rgba(231, 76, 60, 0.8)",
                        stack: "Stack 0",
                        yAxisID: "y-bar",
                        meta: {
                          customValue: dataSet,
                        },
                      },
                    ],
                  },
                  options: {
                    responsive: true,
                    maintainAspectRatio: false,
                    plugins: {
                      legend: {
                        display: true,
                      },
                      datalabels: {
                        display: false,
                      },
                      title: {
                        display: true,
                        text: `Top Positions(${this.coinNames[index]})`,
                      },
                      tooltip: {
                        callbacks: {
                          label: function (tooltipItem) {
                            const dataset = tooltipItem.dataset;
                            const rawData = dataset.meta.customValue;
                            const index = tooltipItem.dataIndex;
                            const shortPercent = rawData[index].shortPercent || 0;
                            const longPercent = rawData[index].longPercent || 0;
                            const longShortRatio =
                              rawData[index].longShortRatio || 0;
                            return `Long: ${longPercent}%\r\nShort: ${shortPercent}%\r\nLong Short Ratio: ${Number(longShortRatio).toFixed(3)}`;
                          },
                        },
                      },
                    },
                    scales: {
                      x: {
                        type: "time",
                        time: {
                          ...(this.periods === "1d" && {
                            round: "day",
                          }),
                          unit:
                            this.periods === "1h" || this.periods === "4h"
                              ? "hour"
                              : this.periods === "1d"
                                ? "day"
                                : "minute",
                        },
                        labels: dataSet.map((item) => item.x),
                        ticks: {
                          maxTicksLimit: 20,
                          ...(this.periods !== "1d" && {
                            stepSize:
                              this.periods === "1h"
                                ? 1
                                : this.periods === "4h"
                                  ? 4
                                  : this.periods === "15m"
                                    ? 15
                                    : 5,
                          }),
                          callback: function (value) {
                            const date = new Date(value);
                            if (periods === "1d") {
                              return date.toLocaleDateString("en-GB", {
                                day: "2-digit",
                                month: "2-digit",
                              });
                            } else {
                              return date.toLocaleTimeString("en-GB", {
                                hour: "2-digit",
                                minute: "2-digit",
                              });
                            }
                          },
                        },
                        stacked: true,
                      },
                      "y-line": {
                        id: "y-line",
                        position: "right",
                        grid: {
                          drawOnChartArea: false,
                        },
                        beginAtZero: false,
                        min: startValue,
                        ticks: {
                          callback: function (value) {
                            return value.toFixed(2);
                          },
                        },
                      },
                      y: {
                        display: false,
                        grid: {
                          display: false,
                        },
                      },
                    },
                  },
                });
              }
            });
          this.fourChartIds
            .slice(0, this.totalChart)
            .forEach((chartId, index) => {
              const canvas = document.getElementById(chartId);
              if (!canvas) return;
              if (canvas.offsetParent === null) return;
              const exist = ChartJS.getChart(canvas);
              if (exist) {
                try { exist.destroy(); } catch (e) {
                  // skip
                }
              }
              const ctx = canvas.getContext("2d");
              if (!ctx) return;
              if (canvas) {
                if (this.fourCharts[index]) {
                  try { this.fourCharts[index].destroy(); } catch (e) {
                    // skip
                  }
                  this.fourCharts[index] = null;
                }

                const dataSet = this.fourChartDataSets[index] || [];
                const minValue = Math.min(
                  ...dataSet.map((item) => item.longShortRatio)
                );
                const roundedValue = Math.floor(minValue / 0.05) * 0.05;
                const startValue =
                  minValue - roundedValue <= 0.05
                    ? roundedValue
                    : roundedValue + 0.05;
                this.fourCharts[index] = new ChartJS(ctx, {
                  type: "bar",
                  data: {
                    datasets: [
                      {
                        label: "Tỷ lệ Long/Short",
                        type: "line",
                        data: dataSet,
                        borderColor: "rgba(0, 0, 0, 1)",
                        pointBackgroundColor: "rgba(255, 255, 255, 1)",
                        pointBorderColor: "rgba(0, 0, 0, 1)",
                        pointBorderWidth: 1.5,
                        pointRadius: 4,
                        pointHoverRadius: 6,
                        fill: true,
                        tension: 0.4,
                        borderWidth: 2,
                        yAxisID: "y-line",
                        meta: {
                          customValue: dataSet,
                        },
                      },
                      {
                        label: "% Tài khoản Long",
                        data: dataSet.map((item) => item.longPercent),
                        backgroundColor: "rgba(0, 209, 112, 0.8)",
                        stack: "Stack 0",
                        yAxisID: "y-bar",
                        meta: {
                          customValue: dataSet,
                        },
                      },
                      {
                        label: "% Tài khoản Short",
                        data: dataSet.map((item) => item.shortPercent),
                        backgroundColor: "rgba(231, 76, 60, 0.8)",
                        stack: "Stack 0",
                        yAxisID: "y-bar",
                        meta: {
                          customValue: dataSet,
                        },
                      },
                    ],
                  },
                  options: {
                    responsive: true,
                    maintainAspectRatio: false,

                    plugins: {
                      datalabels: {
                        display: false,
                      },

                      legend: {
                        display: true,
                      },
                      title: {
                        display: true,
                        text: `Accounts(${this.coinNames[index]})`,
                      },
                      tooltip: {
                        callbacks: {
                          label: function (tooltipItem) {
                            const dataset = tooltipItem.dataset;
                            const rawData = dataset.meta.customValue;
                            const index = tooltipItem.dataIndex;
                            const shortPercent = rawData[index].shortPercent || 0;
                            const longPercent = rawData[index].longPercent || 0;
                            const longShortRatio =
                              rawData[index].longShortRatio || 0;
                            return `Long: ${longPercent}%\r\nShort: ${shortPercent}%\r\nLong Short Ratio: ${Number(longShortRatio).toFixed(3)}`;
                          },
                        },
                      },
                    },
                    scales: {
                      x: {
                        type: "time",
                        time: {
                          ...(this.periods === "1d" && {
                            round: "day",
                          }),
                          unit:
                            this.periods === "1h" || this.periods === "4h"
                              ? "hour"
                              : this.periods === "1d"
                                ? "day"
                                : "minute",
                        },
                        labels: dataSet.map((item) => item.x),
                        ticks: {
                          maxTicksLimit: 20,
                          ...(this.periods !== "1d" && {
                            stepSize:
                              this.periods === "1h"
                                ? 1
                                : this.periods === "4h"
                                  ? 4
                                  : this.periods === "15m"
                                    ? 15
                                    : 5,
                          }),
                          callback: function (value) {
                            const date = new Date(value);
                            if (periods === "1d") {
                              return date.toLocaleDateString("en-GB", {
                                day: "2-digit",
                                month: "2-digit",
                              });
                            } else {
                              return date.toLocaleTimeString("en-GB", {
                                hour: "2-digit",
                                minute: "2-digit",
                              });
                            }
                          },
                        },
                        stacked: true,
                      },

                      "y-line": {
                        position: "right",
                        beginAtZero: false,
                        min: startValue,
                        ticks: {
                          callback: function (value) {
                            return value.toFixed(2);
                          },
                        },
                      },

                      y: {
                        display: false,
                        grid: {
                          display: false,
                        },
                        ticks: {
                          beginAtZero: false,
                          callback: function (value) {
                            return value.toFixed(2);
                          },
                        },
                      },
                    },
                  },
                });
              }
            });
          this.fiveChartIds.slice(0, this.totalChart).forEach((chartId, index) => {
            const canvas = document.getElementById(chartId);
            if (!canvas) return;
            if (canvas.offsetParent === null) return;
            const exist = ChartJS.getChart(canvas);
            if (exist) {
              try { exist.destroy(); } catch (e) {
                // skip
              }
            }
            const ctx = canvas.getContext("2d");
            if (!ctx) return;
            if (canvas) {
              if (this.fiveCharts[index]) {
                try { this.fiveCharts[index].destroy(); } catch (e) {
                  // skip
                }
                this.fiveCharts[index] = null;
              }

              const dataGet = this.fiveChartDataSets[index] || {};
              const totalInFlow = Math.abs(dataGet.totalInFlow || 0);
              let dataTotalInFlow = '';
              if (totalInFlow >= 1000000000) {
                dataTotalInFlow = (totalInFlow / 1000000000).toFixed(2) + "B";
              } else if (totalInFlow >= 1000000) {
                dataTotalInFlow = (totalInFlow / 1000000).toFixed(2) + "M";
              } else if (totalInFlow >= 1000) {
                dataTotalInFlow = (totalInFlow / 1000).toFixed(2) + "K";
              }

              const totalInFlowUsdt = Math.abs(dataGet.totalInFlowUsdt || 0);
              let dataTotalInFlowUsdt = '';
              if (totalInFlowUsdt >= 1000000000) {
                dataTotalInFlowUsdt = (totalInFlowUsdt / 1000000000).toFixed(2) + "B";
              } else if (totalInFlowUsdt >= 1000000) {
                dataTotalInFlowUsdt = (totalInFlowUsdt / 1000000).toFixed(2) + "M";
              } else if (totalInFlowUsdt >= 1000) {
                dataTotalInFlowUsdt = (totalInFlowUsdt / 1000).toFixed(2) + "K";
              }

              const dataSet = dataGet.dataSet || [];
              this.fiveCharts[index] = new ChartJS(ctx, {
                type: "bar",
                data: {
                  labels: dataGet.dates || Array.from({ length: this.inflowDays }, (_, i) => i + 1),
                  datasets: [
                    {
                      label: `${this.inflowDays}d Trading Flow: ${dataTotalInFlow} || ${dataTotalInFlowUsdt}`,
                      data: dataSet,
                      backgroundColor: dataSet.map((value) =>
                        value < 0
                          ? "rgba(255, 0, 0, 0.6)"
                          : "rgba(0, 128, 0, 0.6)"
                      ),
                      borderColor: dataSet.map((value) =>
                        value < 0 ? "rgb(255, 0, 0)" : "rgb(0, 128, 0)"
                      ),
                      borderWidth: 1,
                    },
                  ],
                },
                options: {
                  responsive: true,
                  maintainAspectRatio: false,
                  plugins: {
                    legend: {
                      display: true,
                    },
                    datalabels: {
                      display: false,
                    },
                    title: {
                      display: true,
                      text: `${this.inflowDays}d Trading Flow: ${dataTotalInFlow} || ${dataTotalInFlowUsdt}`,
                      font: {
                        style: "italic",
                      },
                      color: dataGet.totalInFlow < 0 ? "red" : "green",
                      padding: 30,
                    },
                    tooltip: {
  enabled: true,
  callbacks: {
    title: function (tooltipItems) {
      const item = tooltipItems[0];
      return item.label || '';
    },
    label: function (ctx) {
      const v = ctx.parsed?.y;
      const date = ctx.chart.data.labels[ctx.dataIndex];
      if (v == null) return '';
      return `Date: ${date} - Inflow: ${fmtComma(v)}`;
    }
  }
},
                  },
                  scales: {
                    x: {
                      display: false,
                      reverse: true,
                    },
                    y: {
                      display: true,
                      ticks: {
                        callback: function (v) {
                          const a = Math.abs(v);
                          if (a >= 1e12) return (v / 1e12).toFixed(0) + 'T';
                          if (a >= 1e9) return (v / 1e9).toFixed(0) + 'B';
                          if (a >= 1e6) return (v / 1e6).toFixed(0) + 'M';
                          if (a >= 1e3) return (v / 1e3).toFixed(0) + 'K';
                          return Math.round(v);
                        }
                      },
                    },
                  },
                },
              });
            }
          });

          this.sixChartIds.slice(0, this.totalChart).forEach((chartId, index) => {
            const canvas = document.getElementById(chartId);
            if (!canvas) return;
            if (canvas.offsetParent === null) return;
            const exist = ChartJS.getChart(canvas);
            if (exist) {
              try { exist.destroy(); } catch (e) {
                // skip
              }
            }
            const ctx = canvas.getContext("2d");
            if (!ctx) return;
            if (canvas) {
              if (this.sixCharts[index]) {
                try { this.sixCharts[index].destroy(); } catch (e) {
                  // skip
                }
                this.sixCharts[index] = null;
              }

              const dataSet = this.sixChartDataSets[index] || [];
              this.sixCharts[index] = new ChartJS(ctx, {
                type: "line",
                data: {
                  datasets: [
                    {
                      data: dataSet,
                      borderColor: "#f39c12",
                      backgroundColor: "rgba(243, 156, 18, 0.5)",
                      fill: true,
                      tension: 0,
                      borderWidth: 2,
                      pointRadius: 0,
                    },
                  ],
                },
                options: {
                  responsive: true,
                  maintainAspectRatio: false,
                  plugins: {
                    legend: {
                      display: false,
                    },
                    datalabels: {
                      display: false,
                    },
                    title: {
                      display: true,
                      text: `Trading Flow (${this.coinNames[index]})`,
                    },
                    tooltip: {
                      enabled: true,
                      callbacks: {
                        label: function (ctx) {
                          const v = ctx.parsed?.y;
                          if (v == null) return '';
                          const absValue = Math.abs(v);
                          let formattedValue = v;
                          if (absValue >= 1000000000) {
                            formattedValue = (v / 1000000000).toFixed(2) + "B";
                          } else if (absValue >= 1000000) {
                            formattedValue = (v / 1000000).toFixed(2) + "M";
                          } else if (absValue >= 1000) {
                            formattedValue = (v / 1000).toFixed(2) + "K";
                          }
                          return `Inflow: ${formattedValue}`;
                        }
                      }
                    },
                  },
                  scales: {
                    x: {
                      type: "time",
                      time: {
                        unit: "minute",
                      },
                      ticks: {
                        maxTicksLimit: 10,
                      },
                      display: false,
                    },
                    y: {
                      display: true,
                    },
                  },
                  interaction: {
                    mode: "index",
                    intersect: false,
                  },
                },
              });
            }
          });
          this.sevenChartIds.slice(0, this.totalChart).forEach((chartId, index) => {
            const canvas = document.getElementById(chartId);
            if (canvas) {
              if (!canvas) return;
              if (canvas.offsetParent === null) return;
              const exist = ChartJS.getChart(canvas);
              if (exist) {
                try { exist.destroy(); } catch (e) {
                  // skip
                }
              }
              const ctx = canvas.getContext("2d");
              if (!ctx) return;
              if (this.sevenCharts[index]) {
                try { this.sevenCharts[index].destroy(); } catch (e) {
                  // skip
                }
                this.sevenCharts[index] = null;
              }
              const dataSet = this.sevenChartDataSets[index] || [];
              this.sevenCharts[index] = new ChartJS(ctx, {
                type: "line",
                data: {
                  datasets: [
                    {
                      label: `Funding Rate (%)`,
                      data: dataSet,
                      borderColor: "#e91e63",
                      backgroundColor: "rgba(233, 30, 99, 0.25)",
                      fill: true,
                      tension: 0,
                      borderWidth: 2,
                    },
                  ],
                },
                options: {
                  plugins: {
                    legend: {
                      display: true,
                    },
                    datalabels: {
                      display: false,
                    },
                    title: {
                      display: true,
                      text: `Funding Rate (${this.coinNames[index]})`,
                    },
                    tooltip: {
                      enabled: true,
                      callbacks: {
                        label: function (ctx) {
                          const v = ctx.parsed?.y;
                          if (v == null) return '';
                          return `Funding rate: ${Number(v).toFixed(4)}%`;
                        }
                      }
                    },
                  },
                  interaction: {
                    mode: "index",
                    intersect: false,
                  },
                  scales: {
                    x: {
                      type: "time",
                      time: {
                        ...(this.periods === "1d" && {
                          round: "day",
                        }),
                        unit:
                          this.periods === "1h" || this.periods === "4h"
                            ? "hour"
                            : this.periods === "1d"
                              ? "day"
                              : "minute",
                      },
                      labels: dataSet.map((item) => item.x),
                      ticks: {
                        maxTicksLimit: 20,
                        ...(this.periods !== "1d" && {
                          stepSize:
                            this.periods === "1h"
                              ? 1
                              : this.periods === "4h"
                                ? 4
                                : 5,
                        }),
                        callback: (val) => {
                          const ts = typeof val === 'number' ? val : Date.parse(val);
                          if (!Number.isFinite(ts)) return String(val ?? "");
                          const d = new Date(ts);

                          const tz = 'Asia/Ho_Chi_Minh';
                          if (periods === "1d") {
                            return new Intl.DateTimeFormat('en-GB', {
                              timeZone: tz, day: '2-digit', month: '2-digit'
                            }).format(d);
                          }

                          const isHourUnit = periods === "1h" || periods === "4h" || periods === "8h";
                          return new Intl.DateTimeFormat('en-GB', {
                            timeZone: tz,
                            hour: '2-digit',
                            minute: isHourUnit ? undefined : '2-digit'
                          }).format(d);
                        },
                      },
                      stacked: true,
                    },
                    y: {
                      ticks: {
                        callback: (v) => `${Number(v).toFixed(4)}%`,
                      },
                    },
                  },
                  responsive: true,
                  maintainAspectRatio: false,
                },
              });
            }
          });

          // Create Bybit Charts
          // Bybit Open Interest Chart
          this.bybitChartIds.slice(0, this.totalChart).forEach((chartId, index) => {
            const canvas = document.getElementById(chartId);
            if (!canvas || canvas.offsetParent === null) return;

            const exist = ChartJS.getChart(canvas);
            if (exist) {
              try { exist.destroy(); } catch (e) { /* skip */ }
            }

            const ctx = canvas.getContext("2d");
            if (!ctx) return;

            if (this.bybitCharts[index]) {
              try { this.bybitCharts[index].destroy(); } catch (e) { /* skip */ }
              this.bybitCharts[index] = null;
            }

            const dataSet = this.bybitChartDataSets[index] || [];
            const labels = dataSet.map(item => item.x);
            const oi = dataSet.map(item => item.oi);
            const notional = dataSet.map(item => item.notional);

            const yL = niceMinMax(oi, 0.06);
            const yR = niceMinMax(notional, 0.06);
            const LEFT_TICKS = 4;
            const RIGHT_TICKS = 4;
            const leftStep = (yL.max - yL.min) / Math.max(1, LEFT_TICKS - 1);
            const rightStep = (yR.max - yR.min) / Math.max(1, RIGHT_TICKS - 1);

            this.bybitCharts[index] = new ChartJS(ctx, {
              type: "bar",
              data: {
                labels,
                datasets: [
                  {
                    type: 'bar',
                    label: `Open Interest (${this.coinNames[index]?.replace('USDT', '') || 'BTC'})`,
                    data: oi,
                    yAxisID: 'y',
                    backgroundColor: '#f0b90b',
                    borderColor: '#dca600',
                    borderSkipped: false,
                    borderWidth: 0,
                    borderRadius: 2,
                    barPercentage: 0.6,
                    categoryPercentage: 0.8,
                    maxBarThickness: 12,
                    datalabels: { display: false },
                    order: 1
                  },
                  {
                    type: 'line',
                    label: 'Notional Value of Open Interest (USDT)',
                    data: notional,
                    yAxisID: 'y1',
                    borderColor: '#ffffff',
                    borderWidth: 2,
                    order: 999,
                    z: 10,
                    showLine: true,
                    spanGaps: true,
                    pointRadius: 2,
                    pointHoverRadius: 3,
                    pointBackgroundColor: '#0b1220',
                    pointBorderColor: '#e5e7eb',
                    pointBorderWidth: 1,
                    tension: 0.25,
                    cubicInterpolationMode: 'monotone',
                    fill: false,
                    datalabels: { display: false }
                  }
                ],
              },
              options: {
                responsive: true,
                maintainAspectRatio: false,
                layout: { padding: 0 },
                interaction: {
                  mode: 'index',
                  intersect: false
                },
                plugins: {
                  legend: {
                    display: true,
                    reverse: false
                  },
                  datalabels: {
                    display: false,
                  },
                  title: {
                    display: true,
                    text: `Bybit Open Interest(${this.coinNames[index]})`,
                  },
                  tooltip: {
                    backgroundColor: '#111827',
                    borderColor: '#374151',
                    borderWidth: 1,
                    titleColor: '#e5e7eb',
                    bodyColor: '#e5e7eb',
                    callbacks: {
                      title(items) {
                        const ts = items[0]?.parsed.x;
                        return ts ? new Date(ts).toLocaleTimeString() : '';
                      },
                      label(c) {
                        const name = c.dataset.label;
                        const value = c.parsed.y;
                        return ` ${name}: ${fmtComma(value)}`;
                      }
                    }
                  },
                },
                scales: {
                  x: {
                    type: 'time',
                    time: {
                      unit: this.periods === "1h" || this.periods === "4h" ? "hour"
                        : this.periods === "1d" ? "day" : "minute"
                    },
                    grid: {
                      color: 'rgba(255,255,255,0.10)',
                      drawTicks: true,
                      drawOnChartArea: true
                    },
                    offset: false,
                    bounds: 'data',
                    ticks: {
                      color: '#9ca3af',
                      maxTicksLimit: 15,
                      count: 15,
                      autoSkip: true,
                      autoSkipPadding: 8,
                      maxRotation: 55,
                      minRotation: 35,
                      padding: 2,
                      callback: function (value) {
                        const date = new Date(value);
                        if (periods === "1d") {
                          return date.toLocaleDateString("en-GB", { day: "2-digit", month: "2-digit" });
                        } else {
                          return date.toLocaleTimeString("en-GB", { hour: "2-digit", minute: "2-digit" });
                        }
                      },
                    },
                  },
                  y: {
                    position: 'left',
                    min: yL.min,
                    max: yL.max,
                    beginAtZero: false,
                    grid: { color: 'rgba(255,255,255,0.10)', drawOnChartArea: true, drawTicks: true },
                    ticks: {
                      color: '#9ca3af', font: { size: 11 }, padding: 0, count: LEFT_TICKS, stepSize: leftStep,
                      callback: function (v) {
                        const a = Math.abs(v);
                        if (a >= 1e12) return (v / 1e12).toFixed(0) + 'T';
                        if (a >= 1e9) return (v / 1e9).toFixed(0) + 'B';
                        if (a >= 1e6) return (v / 1e6).toFixed(0) + 'M';
                        if (a >= 1e3) return (v / 1e3).toFixed(0) + 'K';
                        return Math.round(v);
                      }
                    },
                    title: { display: false }
                  },
                  y1: {
                    position: 'right',
                    min: yR.min,
                    max: yR.max,
                    beginAtZero: false,
                    grid: { display: false, drawOnChartArea: false },
                    ticks: {
                      color: '#9ca3af', font: { size: 11 }, padding: 0, count: RIGHT_TICKS, stepSize: rightStep,
                      callback: function (v) {
                        const a = Math.abs(v);
                        if (a >= 1e12) return (v / 1e12).toFixed(0) + 'T';
                        if (a >= 1e9) return (v / 1e9).toFixed(0) + 'B';
                        if (a >= 1e6) return (v / 1e6).toFixed(0) + 'M';
                        if (a >= 1e3) return (v / 1e3).toFixed(0) + 'K';
                        return Math.round(v);
                      }
                    },
                    title: { display: false }
                  }
                }
              },
              plugins: [stripeBg]
            });
            if (canvas && canvas.parentNode) {
              canvas.parentNode.style.height = '300px';
            }
          });

          // Bybit Long/Short Accounts Chart
          this.bybitSecondChartIds.slice(0, this.totalChart).forEach((chartId, index) => {
            const canvas = document.getElementById(chartId);
            if (!canvas || canvas.offsetParent === null) return;

            const exist = ChartJS.getChart(canvas);
            if (exist) {
              try { exist.destroy(); } catch (e) { /* skip */ }
            }

            const ctx = canvas.getContext("2d");
            if (!ctx) return;

            if (this.bybitSecondCharts[index]) {
              try { this.bybitSecondCharts[index].destroy(); } catch (e) { /* skip */ }
              this.bybitSecondCharts[index] = null;
            }

            const dataSet = this.bybitSecondChartDataSets[index] || [];
            const minValue = Math.min(...dataSet.map((item) => item.longShortRatio));
            const roundedValue = Math.floor(minValue / 0.05) * 0.05;
            const startValue = minValue - roundedValue <= 0.05 ? roundedValue : roundedValue + 0.05;

            this.bybitSecondCharts[index] = new ChartJS(ctx, {
              type: "bar",
              data: {
                datasets: [
                  {
                    label: "Long/Short (Acc)",
                    type: "line",
                    data: dataSet,
                    borderColor: "rgba(0, 0, 0, 1)",
                    pointBackgroundColor: "rgba(255, 255, 255, 1)",
                    pointBorderColor: "rgba(0, 0, 0, 1)",
                    pointBorderWidth: 1.5,
                    pointRadius: 4,
                    pointHoverRadius: 6,
                    fill: true,
                    tension: 0.4,
                    borderWidth: 2,
                    yAxisID: "y-line",
                    meta: { customValue: dataSet },
                  },
                  {
                    label: "% Tài khoản Long",
                    data: dataSet.map((item) => ({ x: item.x, y: item.longPercent })),
                    backgroundColor: "rgba(0, 209, 112, 0.8)",
                    stack: "Stack 0",
                    yAxisID: "y-bar",
                    meta: { customValue: dataSet },
                  },
                  {
                    label: "% Tài khoản Short",
                    data: dataSet.map((item) => ({ x: item.x, y: item.shortPercent })),
                    backgroundColor: "rgba(231, 76, 60, 0.8)",
                    stack: "Stack 0",
                    yAxisID: "y-bar",
                    meta: { customValue: dataSet },
                  },
                ],
              },
              options: {
                responsive: true,
                maintainAspectRatio: false,
                plugins: {
                  legend: { display: true },
                  datalabels: { display: false },
                  title: {
                    display: true,
                    text: `Bybit Top Accounts(${this.coinNames[index]})`,
                  },
                  tooltip: {
                    callbacks: {
                      label: function (tooltipItem) {
                        const dataset = tooltipItem.dataset;
                        const rawData = dataset.meta.customValue;
                        const index = tooltipItem.dataIndex;
                        const shortPercent = rawData[index].shortPercent || 0;
                        const longPercent = rawData[index].longPercent || 0;
                        const longShortRatio = rawData[index].longShortRatio || 0;
                        return `Long: ${longPercent}%\r\nShort: ${shortPercent}%\r\nLong Short Ratio: ${Number(longShortRatio).toFixed(3)}`;
                      },
                    },
                  },
                },
                scales: {
                  x: {
                    type: "time",
                    time: {
                      ...(periods === "1d" && { round: "day" }),
                      unit: periods === "1h" || periods === "4h" ? "hour" : periods === "1d" ? "day" : "minute",
                    },
                    labels: dataSet.map((item) => item.x),
                    ticks: {
                      maxTicksLimit: 20,
                      ...(periods !== "1d" && {
                        stepSize: periods === "1h" ? 1 : periods === "4h" ? 4 : 5,
                      }),
                      callback: function (value) {
                        const date = new Date(value);
                        if (periods === "1d") {
                          return date.toLocaleDateString("en-GB", { day: "2-digit", month: "2-digit" });
                        } else {
                          return date.toLocaleTimeString("en-GB", { hour: "2-digit", minute: "2-digit" });
                        }
                      },
                    },
                    stacked: true,
                  },
                  "y-line": {
                    id: "y-line",
                    position: "right",
                    grid: { drawOnChartArea: false },
                    beginAtZero: false,
                    min: startValue,
                    ticks: {
                      callback: function (value) {
                        return value.toFixed(2);
                      },
                    },
                  },
                  y: {
                    display: false,
                    grid: { display: false },
                  },
                },
              },
            });
          });

          // Bybit Long/Short Positions Chart
          this.bybitThirdChartIds.slice(0, this.totalChart).forEach((chartId, index) => {
            const canvas = document.getElementById(chartId);
            if (!canvas || canvas.offsetParent === null) return;

            const exist = ChartJS.getChart(canvas);
            if (exist) {
              try { exist.destroy(); } catch (e) { /* skip */ }
            }

            const ctx = canvas.getContext("2d");
            if (!ctx) return;

            if (this.bybitThirdCharts[index]) {
              try { this.bybitThirdCharts[index].destroy(); } catch (e) { /* skip */ }
              this.bybitThirdCharts[index] = null;
            }

            const dataSet = this.bybitThirdChartDataSets[index] || [];
            const minValue = Math.min(...dataSet.map((item) => item.longShortRatio));
            const roundedValue = Math.floor(minValue / 0.05) * 0.05;
            const startValue = minValue - roundedValue <= 0.05 ? roundedValue : roundedValue + 0.05;

            this.bybitThirdCharts[index] = new ChartJS(ctx, {
              type: "bar",
              data: {
                datasets: [
                  {
                    label: "Long/Short (Vị thế)",
                    type: "line",
                    data: dataSet,
                    borderColor: "rgba(0, 0, 0, 1)",
                    pointBackgroundColor: "rgba(255, 255, 255, 1)",
                    pointBorderColor: "rgba(0, 0, 0, 1)",
                    pointBorderWidth: 1.5,
                    pointRadius: 4,
                    pointHoverRadius: 6,
                    fill: true,
                    tension: 0.4,
                    borderWidth: 2,
                    yAxisID: "y-line",
                    meta: { customValue: dataSet },
                  },
                  {
                    label: "% Vị thế Long",
                    data: dataSet.map((item) => ({ x: item.x, y: item.longPercent })),
                    backgroundColor: "rgba(0, 209, 112, 0.8)",
                    stack: "Stack 0",
                    yAxisID: "y-bar",
                    meta: { customValue: dataSet },
                  },
                  {
                    label: "% Vị thế Short",
                    data: dataSet.map((item) => ({ x: item.x, y: item.shortPercent })),
                    backgroundColor: "rgba(231, 76, 60, 0.8)",
                    stack: "Stack 0",
                    yAxisID: "y-bar",
                    meta: { customValue: dataSet },
                  },
                ],
              },
              options: {
                responsive: true,
                maintainAspectRatio: false,
                plugins: {
                  legend: { display: true },
                  datalabels: { display: false },
                  title: {
                    display: true,
                    text: `Bybit Top Positions(${this.coinNames[index]})`,
                  },
                  tooltip: {
                    callbacks: {
                      label: function (tooltipItem) {
                        const dataset = tooltipItem.dataset;
                        const rawData = dataset.meta.customValue;
                        const index = tooltipItem.dataIndex;
                        const shortPercent = rawData[index].shortPercent || 0;
                        const longPercent = rawData[index].longPercent || 0;
                        const longShortRatio = rawData[index].longShortRatio || 0;
                        return `Long: ${longPercent}%\r\nShort: ${shortPercent}%\r\nLong Short Ratio: ${Number(longShortRatio).toFixed(3)}`;
                      },
                    },
                  },
                },
                scales: {
                  x: {
                    type: "time",
                    time: {
                      ...(periods === "1d" && { round: "day" }),
                      unit: periods === "1h" || periods === "4h" ? "hour" : periods === "1d" ? "day" : "minute",
                    },
                    labels: dataSet.map((item) => item.x),
                    ticks: {
                      maxTicksLimit: 20,
                      ...(periods !== "1d" && {
                        stepSize: periods === "1h" ? 1 : periods === "4h" ? 4 : periods === "15m" ? 15 : 5,
                      }),
                      callback: function (value) {
                        const date = new Date(value);
                        if (periods === "1d") {
                          return date.toLocaleDateString("en-GB", { day: "2-digit", month: "2-digit" });
                        } else {
                          return date.toLocaleTimeString("en-GB", { hour: "2-digit", minute: "2-digit" });
                        }
                      },
                    },
                    stacked: true,
                  },
                  "y-line": {
                    id: "y-line",
                    position: "right",
                    grid: { drawOnChartArea: false },
                    beginAtZero: false,
                    min: startValue,
                    ticks: {
                      callback: function (value) {
                        return value.toFixed(2);
                      },
                    },
                  },
                  y: {
                    display: false,
                    grid: { display: false },
                  },
                },
              },
            });
          });

          // Create MEXC Charts
          // MEXC Open Interest Chart
          this.mexcChartIds.slice(0, this.totalChart).forEach((chartId, index) => {
            const canvas = document.getElementById(chartId);
            if (!canvas || canvas.offsetParent === null) return;

            const exist = ChartJS.getChart(canvas);
            if (exist) {
              try { exist.destroy(); } catch (e) { /* skip */ }
            }

            const ctx = canvas.getContext("2d");
            if (!ctx) return;

            if (this.mexcCharts[index]) {
              try { this.mexcCharts[index].destroy(); } catch (e) { /* skip */ }
              this.mexcCharts[index] = null;
            }

            const dataSet = this.mexcChartDataSets[index] || [];
            const labels = dataSet.map(item => item.x);
            const oi = dataSet.map(item => item.oi);
            const notional = dataSet.map(item => item.notional);

            const yL = niceMinMax(oi, 0.06);
            const yR = niceMinMax(notional, 0.06);
            const LEFT_TICKS = 4;
            const RIGHT_TICKS = 4;
            const leftStep = (yL.max - yL.min) / Math.max(1, LEFT_TICKS - 1);
            const rightStep = (yR.max - yR.min) / Math.max(1, RIGHT_TICKS - 1);

            this.mexcCharts[index] = new ChartJS(ctx, {
              type: "bar",
              data: {
                labels,
                datasets: [
                  {
                    type: 'bar',
                    label: `Open Interest (${this.coinNames[index]?.replace('USDT', '') || 'BTC'})`,
                    data: oi,
                    yAxisID: 'y',
                    backgroundColor: '#00d98e',
                    borderColor: '#00b876',
                    borderSkipped: false,
                    borderWidth: 0,
                    borderRadius: 2,
                    barPercentage: 0.6,
                    categoryPercentage: 0.8,
                    maxBarThickness: 12,
                    datalabels: { display: false },
                    order: 1
                  },
                  {
                    type: 'line',
                    label: 'Notional Value of Open Interest (USDT)',
                    data: notional,
                    yAxisID: 'y1',
                    borderColor: '#ffffff',
                    borderWidth: 2,
                    order: 999,
                    z: 10,
                    showLine: true,
                    spanGaps: true,
                    pointRadius: 2,
                    pointHoverRadius: 3,
                    pointBackgroundColor: '#0b1220',
                    pointBorderColor: '#e5e7eb',
                    pointBorderWidth: 1,
                    tension: 0.25,
                    cubicInterpolationMode: 'monotone',
                    fill: false,
                    datalabels: { display: false }
                  }
                ],
              },
              options: {
                responsive: true,
                maintainAspectRatio: false,
                layout: { padding: 0 },
                interaction: {
                  mode: 'index',
                  intersect: false
                },
                plugins: {
                  legend: {
                    display: true,
                    reverse: false
                  },
                  datalabels: {
                    display: false,
                  },
                  title: {
                    display: true,
                    text: `MEXC Open Interest(${this.coinNames[index]})`,
                  },
                  tooltip: {
                    backgroundColor: '#111827',
                    borderColor: '#374151',
                    borderWidth: 1,
                    titleColor: '#e5e7eb',
                    bodyColor: '#e5e7eb',
                    callbacks: {
                      title(items) {
                        const ts = items[0]?.parsed.x;
                        return ts ? new Date(ts).toLocaleTimeString() : '';
                      },
                      label(c) {
                        const name = c.dataset.label;
                        const value = c.parsed.y;
                        return ` ${name}: ${fmtComma(value)}`;
                      }
                    }
                  },
                },
                scales: {
                  x: {
                    type: 'time',
                    time: {
                      unit: this.periods === "1h" || this.periods === "4h" ? "hour"
                        : this.periods === "1d" ? "day" : "minute"
                    },
                    grid: {
                      color: 'rgba(255,255,255,0.10)',
                      drawTicks: true,
                      drawOnChartArea: true
                    },
                    offset: false,
                    bounds: 'data',
                    ticks: {
                      color: '#9ca3af',
                      maxTicksLimit: 15,
                      count: 15,
                      autoSkip: true,
                      autoSkipPadding: 8,
                      maxRotation: 55,
                      minRotation: 35,
                      padding: 2,
                      callback: function (value) {
                        const date = new Date(value);
                        if (periods === "1d") {
                          return date.toLocaleDateString("en-GB", { day: "2-digit", month: "2-digit" });
                        } else {
                          return date.toLocaleTimeString("en-GB", { hour: "2-digit", minute: "2-digit" });
                        }
                      },
                    },
                  },
                  y: {
                    position: 'left',
                    min: yL.min,
                    max: yL.max,
                    beginAtZero: false,
                    grid: { color: 'rgba(255,255,255,0.10)', drawOnChartArea: true, drawTicks: true },
                    ticks: {
                      color: '#9ca3af', font: { size: 11 }, padding: 0, count: LEFT_TICKS, stepSize: leftStep,
                      callback: function (v) {
                        const a = Math.abs(v);
                        if (a >= 1e12) return (v / 1e12).toFixed(0) + 'T';
                        if (a >= 1e9) return (v / 1e9).toFixed(0) + 'B';
                        if (a >= 1e6) return (v / 1e6).toFixed(0) + 'M';
                        if (a >= 1e3) return (v / 1e3).toFixed(0) + 'K';
                        return Math.round(v);
                      }
                    },
                    title: { display: false }
                  },
                  y1: {
                    position: 'right',
                    min: yR.min,
                    max: yR.max,
                    beginAtZero: false,
                    grid: { display: false, drawOnChartArea: false },
                    ticks: {
                      color: '#9ca3af', font: { size: 11 }, padding: 0, count: RIGHT_TICKS, stepSize: rightStep,
                      callback: function (v) {
                        const a = Math.abs(v);
                        if (a >= 1e12) return (v / 1e12).toFixed(0) + 'T';
                        if (a >= 1e9) return (v / 1e9).toFixed(0) + 'B';
                        if (a >= 1e6) return (v / 1e6).toFixed(0) + 'M';
                        if (a >= 1e3) return (v / 1e3).toFixed(0) + 'K';
                        return Math.round(v);
                      }
                    },
                    title: { display: false }
                  }
                }
              },
              plugins: [stripeBg]
            });
            if (canvas && canvas.parentNode) {
              canvas.parentNode.style.height = '300px';
            }
          });

          // MEXC Long/Short Accounts Chart
          this.mexcSecondChartIds.slice(0, this.totalChart).forEach((chartId, index) => {
            const canvas = document.getElementById(chartId);
            if (!canvas || canvas.offsetParent === null) return;

            const exist = ChartJS.getChart(canvas);
            if (exist) {
              try { exist.destroy(); } catch (e) { /* skip */ }
            }

            const ctx = canvas.getContext("2d");
            if (!ctx) return;

            if (this.mexcSecondCharts[index]) {
              try { this.mexcSecondCharts[index].destroy(); } catch (e) { /* skip */ }
              this.mexcSecondCharts[index] = null;
            }

            const dataSet = this.mexcSecondChartDataSets[index] || [];
            const minValue = Math.min(...dataSet.map((item) => item.longShortRatio));
            const roundedValue = Math.floor(minValue / 0.05) * 0.05;
            const startValue = minValue - roundedValue <= 0.05 ? roundedValue : roundedValue + 0.05;

            this.mexcSecondCharts[index] = new ChartJS(ctx, {
              type: "bar",
              data: {
                datasets: [
                  {
                    label: "Long/Short (Acc)",
                    type: "line",
                    data: dataSet,
                    borderColor: "rgba(0, 0, 0, 1)",
                    pointBackgroundColor: "rgba(255, 255, 255, 1)",
                    pointBorderColor: "rgba(0, 0, 0, 1)",
                    pointBorderWidth: 1.5,
                    pointRadius: 4,
                    pointHoverRadius: 6,
                    fill: true,
                    tension: 0.4,
                    borderWidth: 2,
                    yAxisID: "y-line",
                    meta: { customValue: dataSet },
                  },
                  {
                    label: "% Tài khoản Long",
                    data: dataSet.map((item) => ({ x: item.x, y: item.longPercent })),
                    backgroundColor: "rgba(0, 209, 112, 0.8)",
                    stack: "Stack 0",
                    yAxisID: "y-bar",
                    meta: { customValue: dataSet },
                  },
                  {
                    label: "% Tài khoản Short",
                    data: dataSet.map((item) => ({ x: item.x, y: item.shortPercent })),
                    backgroundColor: "rgba(231, 76, 60, 0.8)",
                    stack: "Stack 0",
                    yAxisID: "y-bar",
                    meta: { customValue: dataSet },
                  },
                ],
              },
              options: {
                responsive: true,
                maintainAspectRatio: false,
                plugins: {
                  legend: { display: true },
                  datalabels: { display: false },
                  title: {
                    display: true,
                    text: `MEXC Top Accounts(${this.coinNames[index]})`,
                  },
                  tooltip: {
                    callbacks: {
                      label: function (tooltipItem) {
                        const dataset = tooltipItem.dataset;
                        const rawData = dataset.meta.customValue;
                        const index = tooltipItem.dataIndex;
                        const shortPercent = rawData[index].shortPercent || 0;
                        const longPercent = rawData[index].longPercent || 0;
                        const longShortRatio = rawData[index].longShortRatio || 0;
                        return `Long: ${longPercent}%\r\nShort: ${shortPercent}%\r\nLong Short Ratio: ${Number(longShortRatio).toFixed(3)}`;
                      },
                    },
                  },
                },
                scales: {
                  x: {
                    type: "time",
                    time: {
                      ...(periods === "1d" && { round: "day" }),
                      unit: periods === "1h" || periods === "4h" ? "hour" : periods === "1d" ? "day" : "minute",
                    },
                    labels: dataSet.map((item) => item.x),
                    ticks: {
                      maxTicksLimit: 20,
                      ...(periods !== "1d" && {
                        stepSize: periods === "1h" ? 1 : periods === "4h" ? 4 : 5,
                      }),
                      callback: function (value) {
                        const date = new Date(value);
                        if (periods === "1d") {
                          return date.toLocaleDateString("en-GB", { day: "2-digit", month: "2-digit" });
                        } else {
                          return date.toLocaleTimeString("en-GB", { hour: "2-digit", minute: "2-digit" });
                        }
                      },
                    },
                    stacked: true,
                  },
                  "y-line": {
                    id: "y-line",
                    position: "right",
                    grid: { drawOnChartArea: false },
                    beginAtZero: false,
                    min: startValue,
                    ticks: {
                      callback: function (value) {
                        return value.toFixed(2);
                      },
                    },
                  },
                  y: {
                    display: false,
                    grid: { display: false },
                  },
                },
              },
            });
          });

          // MEXC Long/Short Positions Chart
          this.mexcThirdChartIds.slice(0, this.totalChart).forEach((chartId, index) => {
            const canvas = document.getElementById(chartId);
            if (!canvas || canvas.offsetParent === null) return;

            const exist = ChartJS.getChart(canvas);
            if (exist) {
              try { exist.destroy(); } catch (e) { /* skip */ }
            }

            const ctx = canvas.getContext("2d");
            if (!ctx) return;

            if (this.mexcThirdCharts[index]) {
              try { this.mexcThirdCharts[index].destroy(); } catch (e) { /* skip */ }
              this.mexcThirdCharts[index] = null;
            }

            const dataSet = this.mexcThirdChartDataSets[index] || [];
            const minValue = Math.min(...dataSet.map((item) => item.longShortRatio));
            const roundedValue = Math.floor(minValue / 0.05) * 0.05;
            const startValue = minValue - roundedValue <= 0.05 ? roundedValue : roundedValue + 0.05;

            this.mexcThirdCharts[index] = new ChartJS(ctx, {
              type: "bar",
              data: {
                datasets: [
                  {
                    label: "Long/Short (Vị thế)",
                    type: "line",
                    data: dataSet,
                    borderColor: "rgba(0, 0, 0, 1)",
                    pointBackgroundColor: "rgba(255, 255, 255, 1)",
                    pointBorderColor: "rgba(0, 0, 0, 1)",
                    pointBorderWidth: 1.5,
                    pointRadius: 4,
                    pointHoverRadius: 6,
                    fill: true,
                    tension: 0.4,
                    borderWidth: 2,
                    yAxisID: "y-line",
                    meta: { customValue: dataSet },
                  },
                  {
                    label: "% Vị thế Long",
                    data: dataSet.map((item) => ({ x: item.x, y: item.longPercent })),
                    backgroundColor: "rgba(0, 209, 112, 0.8)",
                    stack: "Stack 0",
                    yAxisID: "y-bar",
                    meta: { customValue: dataSet },
                  },
                  {
                    label: "% Vị thế Short",
                    data: dataSet.map((item) => ({ x: item.x, y: item.shortPercent })),
                    backgroundColor: "rgba(231, 76, 60, 0.8)",
                    stack: "Stack 0",
                    yAxisID: "y-bar",
                    meta: { customValue: dataSet },
                  },
                ],
              },
              options: {
                responsive: true,
                maintainAspectRatio: false,
                plugins: {
                  legend: { display: true },
                  datalabels: { display: false },
                  title: {
                    display: true,
                    text: `MEXC Top Positions(${this.coinNames[index]})`,
                  },
                  tooltip: {
                    callbacks: {
                      label: function (tooltipItem) {
                        const dataset = tooltipItem.dataset;
                        const rawData = dataset.meta.customValue;
                        const index = tooltipItem.dataIndex;
                        const shortPercent = rawData[index].shortPercent || 0;
                        const longPercent = rawData[index].longPercent || 0;
                        const longShortRatio = rawData[index].longShortRatio || 0;
                        return `Long: ${longPercent}%\r\nShort: ${shortPercent}%\r\nLong Short Ratio: ${Number(longShortRatio).toFixed(3)}`;
                      },
                    },
                  },
                },
                scales: {
                  x: {
                    type: "time",
                    time: {
                      ...(periods === "1d" && { round: "day" }),
                      unit: periods === "1h" || periods === "4h" ? "hour" : periods === "1d" ? "day" : "minute",
                    },
                    labels: dataSet.map((item) => item.x),
                    ticks: {
                      maxTicksLimit: 20,
                      ...(periods !== "1d" && {
                        stepSize: periods === "1h" ? 1 : periods === "4h" ? 4 : 5,
                      }),
                      callback: function (value) {
                        const date = new Date(value);
                        if (periods === "1d") {
                          return date.toLocaleDateString("en-GB", { day: "2-digit", month: "2-digit" });
                        } else {
                          return date.toLocaleTimeString("en-GB", { hour: "2-digit", minute: "2-digit" });
                        }
                      },
                    },
                    stacked: true,
                  },
                  "y-line": {
                    id: "y-line",
                    position: "right",
                    grid: { drawOnChartArea: false },
                    beginAtZero: false,
                    min: startValue,
                    ticks: {
                      callback: function (value) {
                        return value.toFixed(2);
                      },
                    },
                  },
                  y: {
                    display: false,
                    grid: { display: false },
                  },
                },
              },
            });
          });

          // MEXC Long/Short Chart
          this.mexcFourChartIds.slice(0, this.totalChart).forEach((chartId, index) => {
            const canvas = document.getElementById(chartId);
            if (!canvas || canvas.offsetParent === null) return;

            const exist = ChartJS.getChart(canvas);
            if (exist) {
              try { exist.destroy(); } catch (e) { /* skip */ }
            }

            const ctx = canvas.getContext("2d");
            if (!ctx) return;

            if (this.mexcFourCharts[index]) {
              try { this.mexcFourCharts[index].destroy(); } catch (e) { /* skip */ }
              this.mexcFourCharts[index] = null;
            }

            const dataSet = this.mexcFourChartDataSets[index] || [];
            const minValue = Math.min(...dataSet.map((item) => item.longShortRatio));
            const roundedValue = Math.floor(minValue / 0.05) * 0.05;
            const startValue = minValue - roundedValue <= 0.05 ? roundedValue : roundedValue + 0.05;

            this.mexcFourCharts[index] = new ChartJS(ctx, {
              type: "bar",
              data: {
                datasets: [
                  {
                    label: "Long/Short",
                    type: "line",
                    data: dataSet,
                    borderColor: "rgba(0, 0, 0, 1)",
                    pointBackgroundColor: "rgba(255, 255, 255, 1)",
                    pointBorderColor: "rgba(0, 0, 0, 1)",
                    pointBorderWidth: 1.5,
                    pointRadius: 4,
                    pointHoverRadius: 6,
                    fill: true,
                    tension: 0.4,
                    borderWidth: 2,
                    yAxisID: "y-line",
                    meta: { customValue: dataSet },
                  },
                  {
                    label: "% Long",
                    data: dataSet.map((item) => ({ x: item.x, y: item.longPercent })),
                    backgroundColor: "rgba(0, 209, 112, 0.8)",
                    stack: "Stack 0",
                    yAxisID: "y-bar",
                    meta: { customValue: dataSet },
                  },
                  {
                    label: "% Short",
                    data: dataSet.map((item) => ({ x: item.x, y: item.shortPercent })),
                    backgroundColor: "rgba(231, 76, 60, 0.8)",
                    stack: "Stack 0",
                    yAxisID: "y-bar",
                    meta: { customValue: dataSet },
                  },
                ],
              },
              options: {
                responsive: true,
                maintainAspectRatio: false,
                plugins: {
                  legend: { display: true },
                  datalabels: { display: false },
                  title: {
                    display: true,
                    text: `MEXC Long/Short(${this.coinNames[index]})`,
                  },
                  tooltip: {
                    callbacks: {
                      label: function (tooltipItem) {
                        const dataset = tooltipItem.dataset;
                        const rawData = dataset.meta.customValue;
                        const index = tooltipItem.dataIndex;
                        const shortPercent = rawData[index].shortPercent || 0;
                        const longPercent = rawData[index].longPercent || 0;
                        const longShortRatio = rawData[index].longShortRatio || 0;
                        return `Long: ${longPercent}%\r\nShort: ${shortPercent}%\r\nLong Short Ratio: ${Number(longShortRatio).toFixed(3)}`;
                      },
                    },
                  },
                },
                scales: {
                  x: {
                    type: "time",
                    time: {
                      ...(periods === "1d" && { round: "day" }),
                      unit: periods === "1h" || periods === "4h" ? "hour" : periods === "1d" ? "day" : "minute",
                    },
                    labels: dataSet.map((item) => item.x),
                    ticks: {
                      maxTicksLimit: 20,
                      ...(periods !== "1d" && {
                        stepSize: periods === "1h" ? 1 : periods === "4h" ? 4 : 5,
                      }),
                      callback: function (value) {
                        const date = new Date(value);
                        if (periods === "1d") {
                          return date.toLocaleDateString("en-GB", { day: "2-digit", month: "2-digit" });
                        } else {
                          return date.toLocaleTimeString("en-GB", { hour: "2-digit", minute: "2-digit" });
                        }
                      },
                    },
                    stacked: true,
                  },
                  "y-line": {
                    id: "y-line",
                    position: "right",
                    grid: { drawOnChartArea: false },
                    beginAtZero: false,
                    min: startValue,
                    ticks: {
                      callback: function (value) {
                        return value.toFixed(2);
                      },
                    },
                  },
                  y: {
                    display: false,
                    grid: { display: false },
                  },
                },
              },
            });
          });

        });
      });
    },
    handleMetrics(list) {
      this.selectedMetrics = Array.isArray(list) ? list : [];
    },
    handleInflowDaysChanged(days) {
      this.inflowDays = days;
      if (this.$refs.menuAllCoins && this.$refs.menuAllCoins.selectedCoin) {
        this.handleSearch({
          coin: this.$refs.menuAllCoins.selectedCoin,
          period: this.periods
        });
      }
    }
  },
  beforeUnmount() {
    const killArr = (arr) => (arr || []).forEach(c => {
      try { c?.destroy(); } catch (e) {
        // skip
      }
    });
    killArr(this.charts);
    killArr(this.secondCharts);
    killArr(this.thirdCharts);
    killArr(this.fourCharts);
    killArr(this.mexcCharts);
    killArr(this.mexcSecondCharts);
    killArr(this.mexcThirdCharts);
    killArr(this.mexcFourCharts);
    killArr(this.bybitCharts);
    killArr(this.bybitSecondCharts);
    killArr(this.bybitThirdCharts);

    this.charts = this.secondCharts = this.thirdCharts =
      this.fourCharts = this.mexcCharts = this.mexcSecondCharts =
      this.mexcThirdCharts = this.mexcFourCharts = this.bybitCharts =
      this.bybitSecondCharts = this.bybitThirdCharts = [];
  },

  deactivated() {
    const killArr = (arr) => (arr || []).forEach(c => {
      try { c?.destroy(); } catch (e) {
        // skip
      }
    });
    killArr(this.charts);
    killArr(this.secondCharts);
    killArr(this.thirdCharts);
    killArr(this.fourCharts);
    killArr(this.mexcCharts);
    killArr(this.mexcSecondCharts);
    killArr(this.mexcThirdCharts);
    killArr(this.mexcFourCharts);
    killArr(this.bybitCharts);
    killArr(this.bybitSecondCharts);
    killArr(this.bybitThirdCharts);
  }
};
</script>
